export const PAYMENT_RESOLUTION_TEXTS = {
  uk: {
    antifraud_error: 'Не вдалося обробити платіж',
    card_status_is_restricted_for_provider: 'Використання картки обмежено',
    client_auth_failed: 'Невдала авторизація',
    customer_is_blocked: 'Спроба оплати заблокована',
    card_expired: 'Закінчився або невірно введений термін дії картки',
    declined_error: 'Не вдалося обробити платіж',
    duplicated_transaction: 'Не вдалося обробити платіж',
    expired: 'Термін дії платіжної сторінки завершився',
    functionality_is_not_permitted: 'Платіж був відхилений Вашим банком',
    connection_error: 'Не вдалося обробити платіж',
    internal_error: 'Не вдалося обробити платіж',
    gateway_internal_error: 'Не вдалося обробити платіж',
    invoke_fatal_error: 'Не вдалося обробити платіж.',
    fatal_error: 'Не вдалося обробити платіж.',
    general_fatal_error: 'Не вдалося обробити платіж.',
    insufficient_funds: 'Недостатньо коштів на Вашій карті',
    invalid_amount: 'Неможливо обробити суму через обмеження/ліміти Вашого банка',
    invalid_card: 'Картка недійсна, закрита або заблокована',
    invalid_card_status: 'Обмеження по картці зі сторони Вашого банку',
    invalid_details: 'Не вдалося обробити платіж',
    issuer_unavailable: 'Платіж був відхилений Вашим банком',
    card_usage_issuer_limit_violation: 'Платіж був відхилений Вашим банком (перевищено ліміт)',
    limit_violation: 'Платіж був відхилений Вашим банком (перевищено ліміт)',
    lost_or_stolen_card: 'Карта втрачена або вкрадена',
    processing_error: 'Не вдалося обробити платіж',
    provider_fatal_error: 'Не вдалося обробити платіж',
    timeout: 'Отриманий таймаут на одному із етапів проведення транзакції',
    blocked_by_firewall: 'Платіж відхилено системою безпеки',
    card_customer_binding_conflict: 'Картка вже закріплена за іншим акаунтом',
    general_decline: 'Не вдалося обробити платіж',
    invalid_cvv: 'Неправильно введений CVV-код',
    ACCESS_DENIED: 'Не вдалося обробити платіж',
    INVALID_CREDENTIALS: 'Не вдалося обробити платіж',
    INVALID_PAN: 'Введений номер платіжної картки є некоректним',
    INVALID_REQUEST: 'Не вдалося обробити платіж',
    TRANSACTION_NOT_FOUND: 'Не вдалося обробити платіж',
    card_is_lost: 'Відмова банка-емітента, карта втрачена',
    card_is_stolen: 'Відмова банка-емітента, карта вкрадена',
    card_status_is_restricted: 'Використання картки обмежено',
    card_usage_frequency_limit_violation: 'Платіж був відхилений Вашим банком (перевищено ліміт)',
    fatal_card_expired: 'Закінчився або невірно введений термін дії картки',
    fatal_decline: 'Не вдалося обробити платіж',
    fatal_timeout: 'Не вдалося обробити платіж',
    contact_issuer: 'Платіж був відхилений Вашим банком',
    issuer_decline: 'Платіж був відхилений Вашим банком',
    pin_tries_limit_was_reached: 'Перевищено допустиму кількість спроб введення PIN-коду',
    provider_error: 'Не вдалося обробити платіж',
    fatal_issuer_unavailable: 'Платіж був відхилений Вашим банком',
    invalid_account: 'Не вдалося обробити платіж',
    INVALID_TOKEN: 'Не вдалося обробити платіж',
    error: 'Не вдалося обробити платіж',
    invalid_expire_date: 'Закінчився або невірно введений термін дії картки',
    invalid_3ds_code: 'Невірний код підтвердження 3D-Secure',
    card_verification_failed: 'Не вдалося верифікувати картку',
    invalid_card_type: 'Відмова вашого банку, даний тип картки є недійсним',
    card_restricted_by_acquirer: 'Обробка транзакцій за цією карткою обмежено',
    card_restricted: 'Використання картки обмежено',
    card_is_not_3ds_enrolled: 'Картка не підтримує верифікацію 3D-Secure',
    card_is_not_3ds_v2_enrolled: 'Картка не підтримує верифікацію 3D-Secure',
    card_is_3ds_enrolled: 'Картка не підтримує верифікацію 3D-Secure',
    unable_to_determine_3ds_enrolment: 'Картка не підтримує верифікацію 3D-Secure',
    card_not_3ds_enrolled: 'Картка не підтримує верифікацію 3D-Secure',
    card_lost: 'Відмова банка-емітента, карта втрачена',
    card_blocked_by_invalid_pin: 'Картку заблоковано через неправильне введення PIN-коду',
    card_3ds_enrolled: 'Для обробки цієї картки потрібна верифікація 3D-Secure',
    auth_fatal_error: 'Не вдалося здійснити авторизацію картки',
    auth_otp_required: 'Для обробки потрібна перевірка OTP',
    auth_3ds_required: 'Для обробки потрібна верифікація 3D-Secure',
    error_during_payment: 'Не вдалося обробити платіж',
    ok: 'Запит завершився: відноситься до успішних і неуспішних транзакцій',
    approved: 'Прийнято',
    held_for_review: 'Відкладено для перевірки',
    wait_for_capture: 'Очікує на створення',
    unable_to_reconcile: 'Неможливо узгодити',
    cannot_reconcile: 'Неможливо узгодити',
    dynamic_pvv_expired: 'Динамічний PVV завершився',
    reconcile_required: 'Необхідно узгодити',
    invalid_cardholder: 'Недійсний власник карти',
    invalid_otp: 'Недійсний OTP',
    auth_cvv_required: 'Потрібна авторизація CVV',
    auth_lookup_required: 'Потрібна перевірка автентифікації',
    invalid_lookup_code: 'Недійсний код пошуку',
    no_routes_by_amount_limits: 'Платіж був відхилений (перевищено ліміт)',
    no_routes_by_turnover_limits: 'Платіж був відхилений (перевищено ліміт)',
    no_routes_by_merchant_account_limits: 'Платіж був відхилений (перевищено ліміт)',
    unable_to_cascade: 'Не вдалося обробити платіж',
    no_routes_by_payment_request_options: 'Не вдалося обробити платіж',
    no_routes_by_merchant_account_status: 'Не вдалося обробити платіж',
    no_routes_by_payment_request_flow: 'Не вдалося обробити платіж',
    no_routes_by_conditions: 'Не вдалося обробити платіж',
    no_routes_by_balance: 'Не вдалося обробити платіж',
    no_routes_by_history: 'Не вдалося обробити платіж',
    no_available_routes: 'Не вдалося обробити платіж',
    unable_to_cascade_due_to_payment_resolution: 'Не вдалося обробити платіж',
    no_routes_by_status: 'Не вдалося обробити платіж',
    unknown: 'Не вдалося обробити платіж',
  },
  en: {
    antifraud_error: 'Unable to process the payment',
    card_status_is_restricted_for_provider: 'Card usage is restricted',
    client_auth_failed: 'Authorization failed',
    customer_is_blocked: 'Payment attempt is blocked',
    card_expired: 'Card expiration date is invalid or expired',
    declined_error: 'Unable to process the payment',
    duplicated_transaction: 'Unable to process the payment',
    expired: 'Payment session has expired',
    functionality_is_not_permitted: 'Payment was declined by your bank',
    connection_error: 'Unable to process the payment',
    internal_error: 'Unable to process the payment',
    gateway_internal_error: 'Unable to process the payment',
    invoke_fatal_error: 'Unable to process the payment',
    fatal_error: 'Unable to process the payment',
    general_fatal_error: 'Unable to process the payment',
    insufficient_funds: 'Insufficient funds on your card',
    invalid_amount: 'Amount cannot be processed due to bank limits',
    invalid_card: 'Card is invalid, closed, or blocked',
    invalid_card_status: 'Card restrictions imposed by your bank',
    invalid_details: 'Unable to process the payment',
    issuer_unavailable: 'Payment was declined by your bank',
    card_usage_issuer_limit_violation: 'Payment was declined by your bank (limit exceeded)',
    limit_violation: 'Payment was declined by your bank (limit exceeded)',
    lost_or_stolen_card: 'Card is lost or stolen',
    processing_error: 'Unable to process the payment',
    provider_fatal_error: 'Unable to process the payment',
    timeout: 'Transaction timed out during processing',
    blocked_by_firewall: 'Payment blocked by security system',
    card_customer_binding_conflict: 'The card is already linked to another account',
    general_decline: 'Unable to process the payment',
    invalid_cvv: 'Invalid CVV code',
    ACCESS_DENIED: 'Unable to process the payment',
    INVALID_CREDENTIALS: 'Unable to process the payment',
    INVALID_PAN: 'Invalid card number',
    INVALID_REQUEST: 'Unable to process the payment',
    TRANSACTION_NOT_FOUND: 'Unable to process the payment',
    card_is_lost: 'Issuer declined: card reported lost',
    card_is_stolen: 'Issuer declined: card reported stolen',
    card_status_is_restricted: 'Card usage is restricted',
    card_usage_frequency_limit_violation: 'Payment was declined by your bank (limit exceeded)',
    fatal_card_expired: 'Card expiration date is invalid or expired',
    fatal_decline: 'Unable to process the payment',
    fatal_timeout: 'Unable to process the payment',
    contact_issuer: 'Payment was declined by your bank',
    issuer_decline: 'Payment was declined by your bank',
    pin_tries_limit_was_reached: 'PIN entry attempts exceeded',
    provider_error: 'Unable to process the payment',
    fatal_issuer_unavailable: 'Payment was declined by your bank',
    invalid_account: 'Unable to process the payment',
    INVALID_TOKEN: 'Unable to process the payment',
    error: 'Unable to process the payment',
    invalid_expire_date: 'Card expiration date is invalid or expired',
    invalid_3ds_code: 'Invalid 3D Secure verification code',
    card_verification_failed: 'Card verification failed',
    invalid_card_type: 'Card type is not supported by your bank',
    card_restricted_by_acquirer: 'Transactions for this card are restricted',
    card_restricted: 'Card usage is restricted',
    card_is_not_3ds_enrolled: 'Card does not support 3D Secure',
    card_is_not_3ds_v2_enrolled: 'Card does not support 3D Secure',
    card_is_3ds_enrolled: 'Card does not support 3D Secure',
    unable_to_determine_3ds_enrolment: 'Card does not support 3D Secure',
    card_not_3ds_enrolled: 'Card does not support 3D Secure',
    card_lost: 'Issuer declined: card reported lost',
    card_blocked_by_invalid_pin: 'Card blocked due to incorrect PIN',
    card_3ds_enrolled: '3D Secure verification required',
    auth_fatal_error: 'Card authorization failed',
    auth_otp_required: 'OTP verification required',
    auth_3ds_required: '3D Secure verification required',
    error_during_payment: 'Unable to process the payment',
    ok: 'Request completed: applies to successful and unsuccessful transactions',
    approved: 'Accepted',
    held_for_review: 'Pending verification',
    wait_for_capture: 'Awaiting creation',
    unable_to_reconcile: 'Unable to reconcile',
    cannot_reconcile: 'Unable to reconcile',
    dynamic_pvv_expired: 'Dynamic PVV has expired',
    reconcile_required: 'Reconciliation required',
    invalid_cardholder: 'Invalid cardholder',
    invalid_otp: 'Invalid OTP',
    auth_cvv_required: 'CVV authorization required',
    auth_lookup_required: 'Authentication check required',
    invalid_lookup_code: 'Invalid lookup code',
    no_routes_by_amount_limits: 'Payment was declined (limit exceeded)',
    no_routes_by_turnover_limits: 'Payment was declined (limit exceeded)',
    no_routes_by_merchant_account_limits: 'Payment was declined (limit exceeded)',
    unable_to_cascade: 'Unable to process the payment',
    no_routes_by_payment_request_options: 'Unable to process the payment',
    no_routes_by_merchant_account_status: 'Unable to process the payment',
    no_routes_by_payment_request_flow: 'Unable to process the payment',
    no_routes_by_conditions: 'Unable to process the payment',
    no_routes_by_balance: 'Unable to process the payment',
    no_routes_by_history: 'Unable to process the payment',
    no_available_routes: 'Unable to process the payment',
    unable_to_cascade_due_to_payment_resolution: 'Unable to process the payment',
    no_routes_by_status: 'Unable to process the payment',
    unknown: 'Unable to process the payment',
  },
  ru: {
    antifraud_error: 'Не удалось обработать платеж',
    card_status_is_restricted_for_provider: 'Использование карты ограничено',
    client_auth_failed: 'Ошибка авторизации',
    customer_is_blocked: 'Попытка оплаты заблокирована',
    card_expired: 'Срок действия карты истек или указан неверно',
    declined_error: 'Не удалось обработать платеж',
    duplicated_transaction: 'Не удалось обработать платеж',
    expired: 'Срок действия платежной страницы истек',
    functionality_is_not_permitted: 'Платеж отклонен вашим банком',
    connection_error: 'Не удалось обработать платеж',
    internal_error: 'Не удалось обработать платеж',
    gateway_internal_error: 'Не удалось обработать платеж',
    invoke_fatal_error: 'Не удалось обработать платеж',
    fatal_error: 'Не удалось обработать платеж',
    general_fatal_error: 'Не удалось обработать платеж',
    insufficient_funds: 'Недостаточно средств на вашей карте',
    invalid_amount: 'Невозможно обработать сумму из-за ограничений или лимитов вашего банка',
    invalid_card: 'Карта недействительна, закрыта или заблокирована',
    invalid_card_status: 'На карту наложены ограничения со стороны вашего банка',
    invalid_details: 'Не удалось обработать платеж',
    issuer_unavailable: 'Платеж отклонен вашим банком',
    card_usage_issuer_limit_violation: 'Платеж отклонен вашим банком (превышен лимит)',
    limit_violation: 'Платеж отклонен вашим банком (превышен лимит)',
    lost_or_stolen_card: 'Карта потеряна или украдена',
    processing_error: 'Не удалось обработать платеж',
    provider_fatal_error: 'Не удалось обработать платеж',
    timeout: 'Превышено время ожидания на одном из этапов обработки транзакции',
    blocked_by_firewall: 'Платеж отклонен системой безопасности',
    card_customer_binding_conflict: 'Карта уже закреплена за другим аккаунтом',
    general_decline: 'Не удалось обработать платеж',
    invalid_cvv: 'Неверно указан CVV-код',
    ACCESS_DENIED: 'Не удалось обработать платеж',
    INVALID_CREDENTIALS: 'Не удалось обработать платеж',
    INVALID_PAN: 'Указан некорректный номер платежной карты',
    INVALID_REQUEST: 'Не удалось обработать платеж',
    TRANSACTION_NOT_FOUND: 'Не удалось обработать платеж',
    card_is_lost: 'Отказ банка-эмитента: карта потеряна',
    card_is_stolen: 'Отказ банка-эмитента: карта украдена',
    card_status_is_restricted: 'Использование карты ограничено',
    card_usage_frequency_limit_violation: 'Платеж отклонен вашим банком (превышен лимит)',
    fatal_card_expired: 'Срок действия карты истек или указан неверно',
    fatal_decline: 'Не удалось обработать платеж',
    fatal_timeout: 'Не удалось обработать платеж',
    contact_issuer: 'Платеж отклонен вашим банком',
    issuer_decline: 'Платеж отклонен вашим банком',
    pin_tries_limit_was_reached: 'Превышено допустимое количество попыток ввода PIN-кода',
    provider_error: 'Не удалось обработать платеж',
    fatal_issuer_unavailable: 'Платеж отклонен вашим банком',
    invalid_account: 'Не удалось обработать платеж',
    INVALID_TOKEN: 'Не удалось обработать платеж',
    error: 'Не удалось обработать платеж',
    invalid_expire_date: 'Срок действия карты истек или указан неверно',
    invalid_3ds_code: 'Неверный код подтверждения 3D Secure',
    card_verification_failed: 'Не удалось проверить карту',
    invalid_card_type: 'Ваш банк отклонил операцию: данный тип карты не поддерживается',
    card_restricted_by_acquirer: 'Обработка транзакций по этой карте ограничена',
    card_restricted: 'Использование карты ограничено',
    card_is_not_3ds_enrolled: 'Карта не поддерживает проверку 3D Secure',
    card_is_not_3ds_v2_enrolled: 'Карта не поддерживает проверку 3D Secure',
    card_is_3ds_enrolled: 'Карта не поддерживает проверку 3D Secure',
    unable_to_determine_3ds_enrolment: 'Не удалось определить поддержку 3D Secure картой',
    card_not_3ds_enrolled: 'Карта не поддерживает проверку 3D Secure',
    card_lost: 'Отказ банка-эмитента: карта потеряна',
    card_blocked_by_invalid_pin: 'Карта заблокирована из-за неверного ввода PIN-кода',
    card_3ds_enrolled: 'Для обработки карты требуется проверка 3D Secure',
    auth_fatal_error: 'Не удалось авторизовать карту',
    auth_otp_required: 'Для обработки требуется подтверждение OTP',
    auth_3ds_required: 'Для обработки требуется проверка 3D Secure',
    error_during_payment: 'Не удалось обработать платеж',
    ok: 'Запрос завершен: относится к успешным и неуспешным транзакциям',
    approved: 'Принято',
    held_for_review: 'Отложено для проверки',
    wait_for_capture: 'Ожидает создания',
    unable_to_reconcile: 'Не удалось выполнить сверку',
    cannot_reconcile: 'Не удалось выполнить сверку',
    dynamic_pvv_expired: 'Срок действия динамического PVV истек',
    reconcile_required: 'Требуется сверка',
    invalid_cardholder: 'Недействительный владелец карты',
    invalid_otp: 'Неверный OTP-код',
    auth_cvv_required: 'Требуется авторизация по CVV',
    auth_lookup_required: 'Требуется проверка аутентификации',
    invalid_lookup_code: 'Неверный код проверки',
    no_routes_by_amount_limits: 'Платеж отклонен (превышен лимит)',
    no_routes_by_turnover_limits: 'Платеж отклонен (превышен лимит)',
    no_routes_by_merchant_account_limits: 'Платеж отклонен (превышен лимит)',
    unable_to_cascade: 'Не удалось обработать платеж',
    no_routes_by_payment_request_options: 'Не удалось обработать платеж',
    no_routes_by_merchant_account_status: 'Не удалось обработать платеж',
    no_routes_by_payment_request_flow: 'Не удалось обработать платеж',
    no_routes_by_conditions: 'Не удалось обработать платеж',
    no_routes_by_balance: 'Не удалось обработать платеж',
    no_routes_by_history: 'Не удалось обработать платеж',
    no_available_routes: 'Не удалось обработать платеж',
    unable_to_cascade_due_to_payment_resolution: 'Не удалось обработать платеж',
    no_routes_by_status: 'Не удалось обработать платеж',
    unknown: 'Не удалось обработать платеж',
  },
  pt: {
    antifraud_error: 'Não foi possível processar o pagamento',
    card_status_is_restricted_for_provider: 'O uso do cartão está restrito',
    client_auth_failed: 'A autorização falhou',
    customer_is_blocked: 'A tentativa de pagamento está bloqueada',
    card_expired: 'A data de validade do cartão é inválida ou expirou',
    declined_error: 'Não foi possível processar o pagamento',
    duplicated_transaction: 'Não foi possível processar o pagamento',
    expired: 'A sessão de pagamento expirou',
    functionality_is_not_permitted: 'O pagamento foi recusado pelo seu banco',
    connection_error: 'Não foi possível processar o pagamento',
    internal_error: 'Não foi possível processar o pagamento',
    gateway_internal_error: 'Não foi possível processar o pagamento',
    invoke_fatal_error: 'Não foi possível processar o pagamento',
    fatal_error: 'Não foi possível processar o pagamento',
    general_fatal_error: 'Não foi possível processar o pagamento',
    insufficient_funds: 'Fundos insuficientes no seu cartão',
    invalid_amount: 'O valor não pode ser processado devido aos limites do banco',
    invalid_card: 'O cartão é inválido, está encerrado ou bloqueado',
    invalid_card_status: 'Restrições do cartão impostas pelo seu banco',
    invalid_details: 'Não foi possível processar o pagamento',
    issuer_unavailable: 'O pagamento foi recusado pelo seu banco',
    card_usage_issuer_limit_violation: 'O pagamento foi recusado pelo seu banco (limite excedido)',
    limit_violation: 'O pagamento foi recusado pelo seu banco (limite excedido)',
    lost_or_stolen_card: 'O cartão foi perdido ou roubado',
    processing_error: 'Não foi possível processar o pagamento',
    provider_fatal_error: 'Não foi possível processar o pagamento',
    timeout: 'A transação expirou durante o processamento',
    blocked_by_firewall: 'Pagamento bloqueado pelo sistema de segurança',
    card_customer_binding_conflict: 'O cartão já está vinculado a outra conta',
    general_decline: 'Não foi possível processar o pagamento',
    invalid_cvv: 'Código CVV inválido',
    ACCESS_DENIED: 'Não foi possível processar o pagamento',
    INVALID_CREDENTIALS: 'Não foi possível processar o pagamento',
    INVALID_PAN: 'Número do cartão inválido',
    INVALID_REQUEST: 'Não foi possível processar o pagamento',
    TRANSACTION_NOT_FOUND: 'Não foi possível processar o pagamento',
    card_is_lost: 'Recusado pelo emissor: cartão comunicado como perdido',
    card_is_stolen: 'Recusado pelo emissor: cartão comunicado como roubado',
    card_status_is_restricted: 'O uso do cartão está restrito',
    card_usage_frequency_limit_violation:
      'O pagamento foi recusado pelo seu banco (limite excedido)',
    fatal_card_expired: 'A data de validade do cartão é inválida ou expirou',
    fatal_decline: 'Não foi possível processar o pagamento',
    fatal_timeout: 'Não foi possível processar o pagamento',
    contact_issuer: 'O pagamento foi recusado pelo seu banco',
    issuer_decline: 'O pagamento foi recusado pelo seu banco',
    pin_tries_limit_was_reached: 'Número de tentativas de PIN excedido',
    provider_error: 'Não foi possível processar o pagamento',
    fatal_issuer_unavailable: 'O pagamento foi recusado pelo seu banco',
    invalid_account: 'Não foi possível processar o pagamento',
    INVALID_TOKEN: 'Não foi possível processar o pagamento',
    error: 'Não foi possível processar o pagamento',
    invalid_expire_date: 'A data de validade do cartão é inválida ou expirou',
    invalid_3ds_code: 'Código de verificação 3D Secure inválido',
    card_verification_failed: 'A verificação do cartão falhou',
    invalid_card_type: 'O tipo de cartão não é suportado pelo seu banco',
    card_restricted_by_acquirer: 'As transações para este cartão estão restritas',
    card_restricted: 'O uso do cartão está restrito',
    card_is_not_3ds_enrolled: 'O cartão não suporta 3D Secure',
    card_is_not_3ds_v2_enrolled: 'O cartão não suporta 3D Secure',
    card_is_3ds_enrolled: 'O cartão não suporta 3D Secure',
    unable_to_determine_3ds_enrolment: 'O cartão não suporta 3D Secure',
    card_not_3ds_enrolled: 'O cartão não suporta 3D Secure',
    card_lost: 'Recusado pelo emissor: cartão comunicado como perdido',
    card_blocked_by_invalid_pin: 'Cartão bloqueado devido a PIN incorreto',
    card_3ds_enrolled: 'Verificação 3D Secure necessária',
    auth_fatal_error: 'A autorização do cartão falhou',
    auth_otp_required: 'Verificação OTP necessária',
    auth_3ds_required: 'Verificação 3D Secure necessária',
    error_during_payment: 'Não foi possível processar o pagamento',
    ok: 'Pedido concluído: aplica-se a transações bem-sucedidas e malsucedidas',
    approved: 'Aceito',
    held_for_review: 'Pendente de verificação',
    wait_for_capture: 'Aguardando criação',
    unable_to_reconcile: 'Não foi possível reconciliar',
    cannot_reconcile: 'Não foi possível reconciliar',
    dynamic_pvv_expired: 'O PVV dinâmico expirou',
    reconcile_required: 'Reconciliação necessária',
    invalid_cardholder: 'Titular do cartão inválido',
    invalid_otp: 'OTP inválido',
    auth_cvv_required: 'Autorização CVV necessária',
    auth_lookup_required: 'Verificação de autenticação necessária',
    invalid_lookup_code: 'Código de consulta inválido',
    no_routes_by_amount_limits: 'O pagamento foi recusado (limite excedido)',
    no_routes_by_turnover_limits: 'O pagamento foi recusado (limite excedido)',
    no_routes_by_merchant_account_limits: 'O pagamento foi recusado (limite excedido)',
    unable_to_cascade: 'Não foi possível processar o pagamento',
    no_routes_by_payment_request_options: 'Não foi possível processar o pagamento',
    no_routes_by_merchant_account_status: 'Não foi possível processar o pagamento',
    no_routes_by_payment_request_flow: 'Não foi possível processar o pagamento',
    no_routes_by_conditions: 'Não foi possível processar o pagamento',
    no_routes_by_balance: 'Não foi possível processar o pagamento',
    no_routes_by_history: 'Não foi possível processar o pagamento',
    no_available_routes: 'Não foi possível processar o pagamento',
    unable_to_cascade_due_to_payment_resolution: 'Não foi possível processar o pagamento',
    no_routes_by_status: 'Não foi possível processar o pagamento',
    unknown: 'Não foi possível processar o pagamento',
  },
  es: {
    antifraud_error: 'No se pudo procesar el pago',
    card_status_is_restricted_for_provider: 'El uso de la tarjeta está restringido',
    client_auth_failed: 'La autorización falló',
    customer_is_blocked: 'El intento de pago está bloqueado',
    card_expired: 'La fecha de vencimiento de la tarjeta no es válida o ha caducado',
    declined_error: 'No se pudo procesar el pago',
    duplicated_transaction: 'No se pudo procesar el pago',
    expired: 'La sesión de pago ha caducado',
    functionality_is_not_permitted: 'El pago fue rechazado por tu banco',
    connection_error: 'No se pudo procesar el pago',
    internal_error: 'No se pudo procesar el pago',
    gateway_internal_error: 'No se pudo procesar el pago',
    invoke_fatal_error: 'No se pudo procesar el pago',
    fatal_error: 'No se pudo procesar el pago',
    general_fatal_error: 'No se pudo procesar el pago',
    insufficient_funds: 'Fondos insuficientes en tu tarjeta',
    invalid_amount: 'El importe no puede procesarse debido a los límites del banco',
    invalid_card: 'La tarjeta no es válida, está cerrada o bloqueada',
    invalid_card_status: 'Restricciones de la tarjeta impuestas por tu banco',
    invalid_details: 'No se pudo procesar el pago',
    issuer_unavailable: 'El pago fue rechazado por tu banco',
    card_usage_issuer_limit_violation: 'El pago fue rechazado por tu banco (límite excedido)',
    limit_violation: 'El pago fue rechazado por tu banco (límite excedido)',
    lost_or_stolen_card: 'La tarjeta se ha perdido o ha sido robada',
    processing_error: 'No se pudo procesar el pago',
    provider_fatal_error: 'No se pudo procesar el pago',
    timeout: 'La transacción agotó el tiempo de espera durante el procesamiento',
    blocked_by_firewall: 'Pago bloqueado por el sistema de seguridad',
    card_customer_binding_conflict: 'La tarjeta ya está vinculada a otra cuenta',
    general_decline: 'No se pudo procesar el pago',
    invalid_cvv: 'Código CVV no válido',
    ACCESS_DENIED: 'No se pudo procesar el pago',
    INVALID_CREDENTIALS: 'No se pudo procesar el pago',
    INVALID_PAN: 'Número de tarjeta no válido',
    INVALID_REQUEST: 'No se pudo procesar el pago',
    TRANSACTION_NOT_FOUND: 'No se pudo procesar el pago',
    card_is_lost: 'Rechazado por el emisor: tarjeta reportada como perdida',
    card_is_stolen: 'Rechazado por el emisor: tarjeta reportada como robada',
    card_status_is_restricted: 'El uso de la tarjeta está restringido',
    card_usage_frequency_limit_violation: 'El pago fue rechazado por tu banco (límite excedido)',
    fatal_card_expired: 'La fecha de vencimiento de la tarjeta no es válida o ha caducado',
    fatal_decline: 'No se pudo procesar el pago',
    fatal_timeout: 'No se pudo procesar el pago',
    contact_issuer: 'El pago fue rechazado por tu banco',
    issuer_decline: 'El pago fue rechazado por tu banco',
    pin_tries_limit_was_reached: 'Se excedió el número de intentos de PIN',
    provider_error: 'No se pudo procesar el pago',
    fatal_issuer_unavailable: 'El pago fue rechazado por tu banco',
    invalid_account: 'No se pudo procesar el pago',
    INVALID_TOKEN: 'No se pudo procesar el pago',
    error: 'No se pudo procesar el pago',
    invalid_expire_date: 'La fecha de vencimiento de la tarjeta no es válida o ha caducado',
    invalid_3ds_code: 'Código de verificación 3D Secure no válido',
    card_verification_failed: 'La verificación de la tarjeta falló',
    invalid_card_type: 'Tu banco no admite este tipo de tarjeta',
    card_restricted_by_acquirer: 'Las transacciones con esta tarjeta están restringidas',
    card_restricted: 'El uso de la tarjeta está restringido',
    card_is_not_3ds_enrolled: 'La tarjeta no admite 3D Secure',
    card_is_not_3ds_v2_enrolled: 'La tarjeta no admite 3D Secure',
    card_is_3ds_enrolled: 'La tarjeta no admite 3D Secure',
    unable_to_determine_3ds_enrolment: 'La tarjeta no admite 3D Secure',
    card_not_3ds_enrolled: 'La tarjeta no admite 3D Secure',
    card_lost: 'Rechazado por el emisor: tarjeta reportada como perdida',
    card_blocked_by_invalid_pin: 'Tarjeta bloqueada debido a PIN incorrecto',
    card_3ds_enrolled: 'Se requiere verificación 3D Secure',
    auth_fatal_error: 'La autorización de la tarjeta falló',
    auth_otp_required: 'Se requiere verificación OTP',
    auth_3ds_required: 'Se requiere verificación 3D Secure',
    error_during_payment: 'No se pudo procesar el pago',
    ok: 'Solicitud completada: se aplica a transacciones exitosas y no exitosas',
    approved: 'Aceptado',
    held_for_review: 'Pendiente de verificación',
    wait_for_capture: 'En espera de creación',
    unable_to_reconcile: 'No se pudo conciliar',
    cannot_reconcile: 'No se pudo conciliar',
    dynamic_pvv_expired: 'El PVV dinámico ha caducado',
    reconcile_required: 'Se requiere conciliación',
    invalid_cardholder: 'Titular de la tarjeta no válido',
    invalid_otp: 'OTP no válido',
    auth_cvv_required: 'Se requiere autorización CVV',
    auth_lookup_required: 'Se requiere verificación de autenticación',
    invalid_lookup_code: 'Código de búsqueda no válido',
    no_routes_by_amount_limits: 'El pago fue rechazado (límite excedido)',
    no_routes_by_turnover_limits: 'El pago fue rechazado (límite excedido)',
    no_routes_by_merchant_account_limits: 'El pago fue rechazado (límite excedido)',
    unable_to_cascade: 'No se pudo procesar el pago',
    no_routes_by_payment_request_options: 'No se pudo procesar el pago',
    no_routes_by_merchant_account_status: 'No se pudo procesar el pago',
    no_routes_by_payment_request_flow: 'No se pudo procesar el pago',
    no_routes_by_conditions: 'No se pudo procesar el pago',
    no_routes_by_balance: 'No se pudo procesar el pago',
    no_routes_by_history: 'No se pudo procesar el pago',
    no_available_routes: 'No se pudo procesar el pago',
    unable_to_cascade_due_to_payment_resolution: 'No se pudo procesar el pago',
    no_routes_by_status: 'No se pudo procesar el pago',
    unknown: 'No se pudo procesar el pago',
  },
  sw: {
    antifraud_error: 'Imeshindikana kuchakata malipo',
    card_status_is_restricted_for_provider: 'Matumizi ya kadi yamezuiwa',
    client_auth_failed: 'Uidhinishaji umeshindikana',
    customer_is_blocked: 'Jaribio la malipo limezuiwa',
    card_expired: 'Tarehe ya kuisha kwa kadi si sahihi au imepitwa na muda',
    declined_error: 'Imeshindikana kuchakata malipo',
    duplicated_transaction: 'Imeshindikana kuchakata malipo',
    expired: 'Kikao cha malipo kimeisha muda',
    functionality_is_not_permitted: 'Malipo yamekataliwa na benki yako',
    connection_error: 'Imeshindikana kuchakata malipo',
    internal_error: 'Imeshindikana kuchakata malipo',
    gateway_internal_error: 'Imeshindikana kuchakata malipo',
    invoke_fatal_error: 'Imeshindikana kuchakata malipo',
    fatal_error: 'Imeshindikana kuchakata malipo',
    general_fatal_error: 'Imeshindikana kuchakata malipo',
    insufficient_funds: 'Salio kwenye kadi yako halitoshi',
    invalid_amount: 'Kiasi hakiwezi kuchakatwa kutokana na vikomo vya benki',
    invalid_card: 'Kadi si halali, imefungwa, au imezuiwa',
    invalid_card_status: 'Vizuizi vya kadi vimewekwa na benki yako',
    invalid_details: 'Imeshindikana kuchakata malipo',
    issuer_unavailable: 'Malipo yamekataliwa na benki yako',
    card_usage_issuer_limit_violation: 'Malipo yamekataliwa na benki yako (kikomo kimezidi)',
    limit_violation: 'Malipo yamekataliwa na benki yako (kikomo kimezidi)',
    lost_or_stolen_card: 'Kadi imepotea au imeibiwa',
    processing_error: 'Imeshindikana kuchakata malipo',
    provider_fatal_error: 'Imeshindikana kuchakata malipo',
    timeout: 'Muda wa muamala umeisha wakati wa kuchakata',
    blocked_by_firewall: 'Malipo yamezuiwa na mfumo wa usalama',
    card_customer_binding_conflict: 'Kadi tayari imeunganishwa na akaunti nyingine',
    general_decline: 'Imeshindikana kuchakata malipo',
    invalid_cvv: 'Msimbo wa CVV si sahihi',
    ACCESS_DENIED: 'Imeshindikana kuchakata malipo',
    INVALID_CREDENTIALS: 'Imeshindikana kuchakata malipo',
    INVALID_PAN: 'Nambari ya kadi si sahihi',
    INVALID_REQUEST: 'Imeshindikana kuchakata malipo',
    TRANSACTION_NOT_FOUND: 'Imeshindikana kuchakata malipo',
    card_is_lost: 'Imekataliwa na mtoaji: kadi imeripotiwa kupotea',
    card_is_stolen: 'Imekataliwa na mtoaji: kadi imeripotiwa kuibiwa',
    card_status_is_restricted: 'Matumizi ya kadi yamezuiwa',
    card_usage_frequency_limit_violation: 'Malipo yamekataliwa na benki yako (kikomo kimezidi)',
    fatal_card_expired: 'Tarehe ya kuisha kwa kadi si sahihi au imepitwa na muda',
    fatal_decline: 'Imeshindikana kuchakata malipo',
    fatal_timeout: 'Imeshindikana kuchakata malipo',
    contact_issuer: 'Malipo yamekataliwa na benki yako',
    issuer_decline: 'Malipo yamekataliwa na benki yako',
    pin_tries_limit_was_reached: 'Idadi ya majaribio ya kuingiza PIN imezidi',
    provider_error: 'Imeshindikana kuchakata malipo',
    fatal_issuer_unavailable: 'Malipo yamekataliwa na benki yako',
    invalid_account: 'Imeshindikana kuchakata malipo',
    INVALID_TOKEN: 'Imeshindikana kuchakata malipo',
    error: 'Imeshindikana kuchakata malipo',
    invalid_expire_date: 'Tarehe ya kuisha kwa kadi si sahihi au imepitwa na muda',
    invalid_3ds_code: 'Msimbo wa uthibitishaji wa 3D Secure si sahihi',
    card_verification_failed: 'Uthibitishaji wa kadi umeshindikana',
    invalid_card_type: 'Aina hii ya kadi haiungwi mkono na benki yako',
    card_restricted_by_acquirer: 'Miamala ya kadi hii imezuiwa',
    card_restricted: 'Matumizi ya kadi yamezuiwa',
    card_is_not_3ds_enrolled: 'Kadi haiungi mkono 3D Secure',
    card_is_not_3ds_v2_enrolled: 'Kadi haiungi mkono 3D Secure',
    card_is_3ds_enrolled: 'Kadi haiungi mkono 3D Secure',
    unable_to_determine_3ds_enrolment: 'Kadi haiungi mkono 3D Secure',
    card_not_3ds_enrolled: 'Kadi haiungi mkono 3D Secure',
    card_lost: 'Imekataliwa na mtoaji: kadi imeripotiwa kupotea',
    card_blocked_by_invalid_pin: 'Kadi imezuiwa kutokana na PIN isiyo sahihi',
    card_3ds_enrolled: 'Uthibitishaji wa 3D Secure unahitajika',
    auth_fatal_error: 'Uidhinishaji wa kadi umeshindikana',
    auth_otp_required: 'Uthibitishaji wa OTP unahitajika',
    auth_3ds_required: 'Uthibitishaji wa 3D Secure unahitajika',
    error_during_payment: 'Imeshindikana kuchakata malipo',
    ok: 'Ombi limekamilika: linatumika kwa miamala iliyofanikiwa na isiyofanikiwa',
    approved: 'Imekubaliwa',
    held_for_review: 'Inasubiri uthibitishaji',
    wait_for_capture: 'Inasubiri kuundwa',
    unable_to_reconcile: 'Imeshindikana kufanya ulinganishaji',
    cannot_reconcile: 'Imeshindikana kufanya ulinganishaji',
    dynamic_pvv_expired: 'PVV ya muda imeisha muda',
    reconcile_required: 'Ulinganishaji unahitajika',
    invalid_cardholder: 'Mwenye kadi si sahihi',
    invalid_otp: 'OTP si sahihi',
    auth_cvv_required: 'Uidhinishaji wa CVV unahitajika',
    auth_lookup_required: 'Ukaguzi wa uthibitishaji unahitajika',
    invalid_lookup_code: 'Msimbo wa utafutaji si sahihi',
    no_routes_by_amount_limits: 'Malipo yamekataliwa (kikomo kimezidi)',
    no_routes_by_turnover_limits: 'Malipo yamekataliwa (kikomo kimezidi)',
    no_routes_by_merchant_account_limits: 'Malipo yamekataliwa (kikomo kimezidi)',
    unable_to_cascade: 'Imeshindikana kuchakata malipo',
    no_routes_by_payment_request_options: 'Imeshindikana kuchakata malipo',
    no_routes_by_merchant_account_status: 'Imeshindikana kuchakata malipo',
    no_routes_by_payment_request_flow: 'Imeshindikana kuchakata malipo',
    no_routes_by_conditions: 'Imeshindikana kuchakata malipo',
    no_routes_by_balance: 'Imeshindikana kuchakata malipo',
    no_routes_by_history: 'Imeshindikana kuchakata malipo',
    no_available_routes: 'Imeshindikana kuchakata malipo',
    unable_to_cascade_due_to_payment_resolution: 'Imeshindikana kuchakata malipo',
    no_routes_by_status: 'Imeshindikana kuchakata malipo',
    unknown: 'Imeshindikana kuchakata malipo',
  },
  uz: {
    antifraud_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    card_status_is_restricted_for_provider: 'Kartadan foydalanish cheklangan',
    client_auth_failed: 'Avtorizatsiya muvaffaqiyatsiz tugadi',
    customer_is_blocked: 'To‘lov urinishi bloklandi',
    card_expired: 'Kartaning amal qilish muddati noto‘g‘ri yoki tugagan',
    declined_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    duplicated_transaction: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    expired: 'To‘lov sessiyasi muddati tugadi',
    functionality_is_not_permitted: 'To‘lov bankingiz tomonidan rad etildi',
    connection_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    internal_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    gateway_internal_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    invoke_fatal_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    fatal_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    general_fatal_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    insufficient_funds: 'Kartangizda mablag‘ yetarli emas',
    invalid_amount: 'Bank limitlari sababli summani qayta ishlash imkoni yo‘q',
    invalid_card: 'Karta yaroqsiz, yopilgan yoki bloklangan',
    invalid_card_status: 'Bankingiz tomonidan karta cheklovlari qo‘yilgan',
    invalid_details: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    issuer_unavailable: 'To‘lov bankingiz tomonidan rad etildi',
    card_usage_issuer_limit_violation: 'To‘lov bankingiz tomonidan rad etildi (limit oshib ketdi)',
    limit_violation: 'To‘lov bankingiz tomonidan rad etildi (limit oshib ketdi)',
    lost_or_stolen_card: 'Karta yo‘qolgan yoki o‘g‘irlangan',
    processing_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    provider_fatal_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    timeout: 'Tranzaksiyani qayta ishlash vaqtida kutish vaqti tugadi',
    blocked_by_firewall: 'To‘lov xavfsizlik tizimi tomonidan bloklandi',
    card_customer_binding_conflict: 'Karta allaqachon boshqa hisobga biriktirilgan',
    general_decline: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    invalid_cvv: 'CVV kodi noto‘g‘ri',
    ACCESS_DENIED: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    INVALID_CREDENTIALS: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    INVALID_PAN: 'Karta raqami noto‘g‘ri',
    INVALID_REQUEST: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    TRANSACTION_NOT_FOUND: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    card_is_lost: 'Emitent rad etdi: karta yo‘qolgan deb xabar qilingan',
    card_is_stolen: 'Emitent rad etdi: karta o‘g‘irlangan deb xabar qilingan',
    card_status_is_restricted: 'Kartadan foydalanish cheklangan',
    card_usage_frequency_limit_violation:
      'To‘lov bankingiz tomonidan rad etildi (limit oshib ketdi)',
    fatal_card_expired: 'Kartaning amal qilish muddati noto‘g‘ri yoki tugagan',
    fatal_decline: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    fatal_timeout: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    contact_issuer: 'To‘lov bankingiz tomonidan rad etildi',
    issuer_decline: 'To‘lov bankingiz tomonidan rad etildi',
    pin_tries_limit_was_reached: 'PIN kiritish urinishlari soni oshib ketdi',
    provider_error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    fatal_issuer_unavailable: 'To‘lov bankingiz tomonidan rad etildi',
    invalid_account: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    INVALID_TOKEN: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    error: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    invalid_expire_date: 'Kartaning amal qilish muddati noto‘g‘ri yoki tugagan',
    invalid_3ds_code: '3D Secure tasdiqlash kodi noto‘g‘ri',
    card_verification_failed: 'Kartani tekshirish muvaffaqiyatsiz tugadi',
    invalid_card_type: 'Bu karta turi bankingiz tomonidan qo‘llab-quvvatlanmaydi',
    card_restricted_by_acquirer: 'Bu karta bo‘yicha tranzaksiyalar cheklangan',
    card_restricted: 'Kartadan foydalanish cheklangan',
    card_is_not_3ds_enrolled: 'Karta 3D Secure’ni qo‘llab-quvvatlamaydi',
    card_is_not_3ds_v2_enrolled: 'Karta 3D Secure’ni qo‘llab-quvvatlamaydi',
    card_is_3ds_enrolled: 'Karta 3D Secure’ni qo‘llab-quvvatlamaydi',
    unable_to_determine_3ds_enrolment: 'Karta 3D Secure’ni qo‘llab-quvvatlamaydi',
    card_not_3ds_enrolled: 'Karta 3D Secure’ni qo‘llab-quvvatlamaydi',
    card_lost: 'Emitent rad etdi: karta yo‘qolgan deb xabar qilingan',
    card_blocked_by_invalid_pin: 'Karta noto‘g‘ri PIN sababli bloklandi',
    card_3ds_enrolled: '3D Secure tasdiqlashi talab qilinadi',
    auth_fatal_error: 'Karta avtorizatsiyasi muvaffaqiyatsiz tugadi',
    auth_otp_required: 'OTP tasdiqlashi talab qilinadi',
    auth_3ds_required: '3D Secure tasdiqlashi talab qilinadi',
    error_during_payment: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    ok: 'So‘rov yakunlandi: muvaffaqiyatli va muvaffaqiyatsiz tranzaksiyalarga tegishli',
    approved: 'Qabul qilindi',
    held_for_review: 'Tekshiruv kutilmoqda',
    wait_for_capture: 'Yaratilish kutilmoqda',
    unable_to_reconcile: 'Solishtirishni amalga oshirib bo‘lmadi',
    cannot_reconcile: 'Solishtirishni amalga oshirib bo‘lmadi',
    dynamic_pvv_expired: 'Dinamik PVV muddati tugadi',
    reconcile_required: 'Solishtirish talab qilinadi',
    invalid_cardholder: 'Karta egasi noto‘g‘ri',
    invalid_otp: 'OTP noto‘g‘ri',
    auth_cvv_required: 'CVV avtorizatsiyasi talab qilinadi',
    auth_lookup_required: 'Autentifikatsiya tekshiruvi talab qilinadi',
    invalid_lookup_code: 'Qidiruv kodi noto‘g‘ri',
    no_routes_by_amount_limits: 'To‘lov rad etildi (limit oshib ketdi)',
    no_routes_by_turnover_limits: 'To‘lov rad etildi (limit oshib ketdi)',
    no_routes_by_merchant_account_limits: 'To‘lov rad etildi (limit oshib ketdi)',
    unable_to_cascade: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    no_routes_by_payment_request_options: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    no_routes_by_merchant_account_status: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    no_routes_by_payment_request_flow: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    no_routes_by_conditions: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    no_routes_by_balance: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    no_routes_by_history: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    no_available_routes: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    unable_to_cascade_due_to_payment_resolution: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    no_routes_by_status: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
    unknown: 'To‘lovni qayta ishlash imkoni bo‘lmadi',
  },
  de: {
    antifraud_error: 'Die Zahlung konnte nicht verarbeitet werden',
    card_status_is_restricted_for_provider: 'Die Kartennutzung ist eingeschränkt',
    client_auth_failed: 'Autorisierung fehlgeschlagen',
    customer_is_blocked: 'Der Zahlungsversuch wurde blockiert',
    card_expired: 'Das Ablaufdatum der Karte ist ungültig oder abgelaufen',
    declined_error: 'Die Zahlung konnte nicht verarbeitet werden',
    duplicated_transaction: 'Die Zahlung konnte nicht verarbeitet werden',
    expired: 'Die Zahlungssitzung ist abgelaufen',
    functionality_is_not_permitted: 'Die Zahlung wurde von Ihrer Bank abgelehnt',
    connection_error: 'Die Zahlung konnte nicht verarbeitet werden',
    internal_error: 'Die Zahlung konnte nicht verarbeitet werden',
    gateway_internal_error: 'Die Zahlung konnte nicht verarbeitet werden',
    invoke_fatal_error: 'Die Zahlung konnte nicht verarbeitet werden',
    fatal_error: 'Die Zahlung konnte nicht verarbeitet werden',
    general_fatal_error: 'Die Zahlung konnte nicht verarbeitet werden',
    insufficient_funds: 'Nicht genügend Guthaben auf Ihrer Karte',
    invalid_amount: 'Der Betrag kann aufgrund von Banklimits nicht verarbeitet werden',
    invalid_card: 'Die Karte ist ungültig, geschlossen oder gesperrt',
    invalid_card_status: 'Von Ihrer Bank festgelegte Karteneinschränkungen',
    invalid_details: 'Die Zahlung konnte nicht verarbeitet werden',
    issuer_unavailable: 'Die Zahlung wurde von Ihrer Bank abgelehnt',
    card_usage_issuer_limit_violation:
      'Die Zahlung wurde von Ihrer Bank abgelehnt (Limit überschritten)',
    limit_violation: 'Die Zahlung wurde von Ihrer Bank abgelehnt (Limit überschritten)',
    lost_or_stolen_card: 'Die Karte wurde verloren oder gestohlen',
    processing_error: 'Die Zahlung konnte nicht verarbeitet werden',
    provider_fatal_error: 'Die Zahlung konnte nicht verarbeitet werden',
    timeout: 'Zeitüberschreitung bei der Transaktion während der Verarbeitung',
    blocked_by_firewall: 'Zahlung durch das Sicherheitssystem blockiert',
    card_customer_binding_conflict: 'Die Karte ist bereits einem anderen Konto zugeordnet',
    general_decline: 'Die Zahlung konnte nicht verarbeitet werden',
    invalid_cvv: 'Ungültiger CVV-Code',
    ACCESS_DENIED: 'Die Zahlung konnte nicht verarbeitet werden',
    INVALID_CREDENTIALS: 'Die Zahlung konnte nicht verarbeitet werden',
    INVALID_PAN: 'Ungültige Kartennummer',
    INVALID_REQUEST: 'Die Zahlung konnte nicht verarbeitet werden',
    TRANSACTION_NOT_FOUND: 'Die Zahlung konnte nicht verarbeitet werden',
    card_is_lost: 'Vom Aussteller abgelehnt: Karte als verloren gemeldet',
    card_is_stolen: 'Vom Aussteller abgelehnt: Karte als gestohlen gemeldet',
    card_status_is_restricted: 'Die Kartennutzung ist eingeschränkt',
    card_usage_frequency_limit_violation:
      'Die Zahlung wurde von Ihrer Bank abgelehnt (Limit überschritten)',
    fatal_card_expired: 'Das Ablaufdatum der Karte ist ungültig oder abgelaufen',
    fatal_decline: 'Die Zahlung konnte nicht verarbeitet werden',
    fatal_timeout: 'Die Zahlung konnte nicht verarbeitet werden',
    contact_issuer: 'Die Zahlung wurde von Ihrer Bank abgelehnt',
    issuer_decline: 'Die Zahlung wurde von Ihrer Bank abgelehnt',
    pin_tries_limit_was_reached: 'Maximale Anzahl an PIN-Eingabeversuchen überschritten',
    provider_error: 'Die Zahlung konnte nicht verarbeitet werden',
    fatal_issuer_unavailable: 'Die Zahlung wurde von Ihrer Bank abgelehnt',
    invalid_account: 'Die Zahlung konnte nicht verarbeitet werden',
    INVALID_TOKEN: 'Die Zahlung konnte nicht verarbeitet werden',
    error: 'Die Zahlung konnte nicht verarbeitet werden',
    invalid_expire_date: 'Das Ablaufdatum der Karte ist ungültig oder abgelaufen',
    invalid_3ds_code: 'Ungültiger 3D-Secure-Verifizierungscode',
    card_verification_failed: 'Kartenverifizierung fehlgeschlagen',
    invalid_card_type: 'Dieser Kartentyp wird von Ihrer Bank nicht unterstützt',
    card_restricted_by_acquirer: 'Transaktionen mit dieser Karte sind eingeschränkt',
    card_restricted: 'Die Kartennutzung ist eingeschränkt',
    card_is_not_3ds_enrolled: 'Die Karte unterstützt 3D Secure nicht',
    card_is_not_3ds_v2_enrolled: 'Die Karte unterstützt 3D Secure nicht',
    card_is_3ds_enrolled: 'Die Karte unterstützt 3D Secure nicht',
    unable_to_determine_3ds_enrolment: 'Die Karte unterstützt 3D Secure nicht',
    card_not_3ds_enrolled: 'Die Karte unterstützt 3D Secure nicht',
    card_lost: 'Vom Aussteller abgelehnt: Karte als verloren gemeldet',
    card_blocked_by_invalid_pin: 'Karte wegen falscher PIN gesperrt',
    card_3ds_enrolled: '3D-Secure-Verifizierung erforderlich',
    auth_fatal_error: 'Kartenautorisierung fehlgeschlagen',
    auth_otp_required: 'OTP-Verifizierung erforderlich',
    auth_3ds_required: '3D-Secure-Verifizierung erforderlich',
    error_during_payment: 'Die Zahlung konnte nicht verarbeitet werden',
    ok: 'Anfrage abgeschlossen: gilt für erfolgreiche und fehlgeschlagene Transaktionen',
    approved: 'Akzeptiert',
    held_for_review: 'Verifizierung ausstehend',
    wait_for_capture: 'Erstellung ausstehend',
    unable_to_reconcile: 'Abgleich nicht möglich',
    cannot_reconcile: 'Abgleich nicht möglich',
    dynamic_pvv_expired: 'Dynamischer PVV ist abgelaufen',
    reconcile_required: 'Abgleich erforderlich',
    invalid_cardholder: 'Ungültiger Karteninhaber',
    invalid_otp: 'Ungültiges OTP',
    auth_cvv_required: 'CVV-Autorisierung erforderlich',
    auth_lookup_required: 'Authentifizierungsprüfung erforderlich',
    invalid_lookup_code: 'Ungültiger Suchcode',
    no_routes_by_amount_limits: 'Die Zahlung wurde abgelehnt (Limit überschritten)',
    no_routes_by_turnover_limits: 'Die Zahlung wurde abgelehnt (Limit überschritten)',
    no_routes_by_merchant_account_limits: 'Die Zahlung wurde abgelehnt (Limit überschritten)',
    unable_to_cascade: 'Die Zahlung konnte nicht verarbeitet werden',
    no_routes_by_payment_request_options: 'Die Zahlung konnte nicht verarbeitet werden',
    no_routes_by_merchant_account_status: 'Die Zahlung konnte nicht verarbeitet werden',
    no_routes_by_payment_request_flow: 'Die Zahlung konnte nicht verarbeitet werden',
    no_routes_by_conditions: 'Die Zahlung konnte nicht verarbeitet werden',
    no_routes_by_balance: 'Die Zahlung konnte nicht verarbeitet werden',
    no_routes_by_history: 'Die Zahlung konnte nicht verarbeitet werden',
    no_available_routes: 'Die Zahlung konnte nicht verarbeitet werden',
    unable_to_cascade_due_to_payment_resolution: 'Die Zahlung konnte nicht verarbeitet werden',
    no_routes_by_status: 'Die Zahlung konnte nicht verarbeitet werden',
    unknown: 'Die Zahlung konnte nicht verarbeitet werden',
  },
  tr: {
    antifraud_error: 'Ödeme işlenemedi',
    card_status_is_restricted_for_provider: 'Kart kullanımı kısıtlı',
    client_auth_failed: 'Yetkilendirme başarısız',
    customer_is_blocked: 'Ödeme denemesi engellendi',
    card_expired: 'Kart son kullanma tarihi geçersiz veya süresi dolmuş',
    declined_error: 'Ödeme işlenemedi',
    duplicated_transaction: 'Ödeme işlenemedi',
    expired: 'Ödeme oturumunun süresi doldu',
    functionality_is_not_permitted: 'Ödeme bankanız tarafından reddedildi',
    connection_error: 'Ödeme işlenemedi',
    internal_error: 'Ödeme işlenemedi',
    gateway_internal_error: 'Ödeme işlenemedi',
    invoke_fatal_error: 'Ödeme işlenemedi',
    fatal_error: 'Ödeme işlenemedi',
    general_fatal_error: 'Ödeme işlenemedi',
    insufficient_funds: 'Kartınızda yeterli bakiye yok',
    invalid_amount: 'Tutar, banka limitleri nedeniyle işlenemiyor',
    invalid_card: 'Kart geçersiz, kapalı veya bloke edilmiş',
    invalid_card_status: 'Bankanız tarafından uygulanan kart kısıtlamaları',
    invalid_details: 'Ödeme işlenemedi',
    issuer_unavailable: 'Ödeme bankanız tarafından reddedildi',
    card_usage_issuer_limit_violation: 'Ödeme bankanız tarafından reddedildi (limit aşıldı)',
    limit_violation: 'Ödeme bankanız tarafından reddedildi (limit aşıldı)',
    lost_or_stolen_card: 'Kart kayıp veya çalıntı',
    processing_error: 'Ödeme işlenemedi',
    provider_fatal_error: 'Ödeme işlenemedi',
    timeout: 'İşlem sırasında zaman aşımı oluştu',
    blocked_by_firewall: 'Ödeme güvenlik sistemi tarafından engellendi',
    card_customer_binding_conflict: 'Kart zaten başka bir hesaba bağlı',
    general_decline: 'Ödeme işlenemedi',
    invalid_cvv: 'Geçersiz CVV kodu',
    ACCESS_DENIED: 'Ödeme işlenemedi',
    INVALID_CREDENTIALS: 'Ödeme işlenemedi',
    INVALID_PAN: 'Geçersiz kart numarası',
    INVALID_REQUEST: 'Ödeme işlenemedi',
    TRANSACTION_NOT_FOUND: 'Ödeme işlenemedi',
    card_is_lost: 'Kartı veren kuruluş reddetti: kart kayıp olarak bildirilmiş',
    card_is_stolen: 'Kartı veren kuruluş reddetti: kart çalıntı olarak bildirilmiş',
    card_status_is_restricted: 'Kart kullanımı kısıtlı',
    card_usage_frequency_limit_violation: 'Ödeme bankanız tarafından reddedildi (limit aşıldı)',
    fatal_card_expired: 'Kart son kullanma tarihi geçersiz veya süresi dolmuş',
    fatal_decline: 'Ödeme işlenemedi',
    fatal_timeout: 'Ödeme işlenemedi',
    contact_issuer: 'Ödeme bankanız tarafından reddedildi',
    issuer_decline: 'Ödeme bankanız tarafından reddedildi',
    pin_tries_limit_was_reached: 'PIN giriş deneme sayısı aşıldı',
    provider_error: 'Ödeme işlenemedi',
    fatal_issuer_unavailable: 'Ödeme bankanız tarafından reddedildi',
    invalid_account: 'Ödeme işlenemedi',
    INVALID_TOKEN: 'Ödeme işlenemedi',
    error: 'Ödeme işlenemedi',
    invalid_expire_date: 'Kart son kullanma tarihi geçersiz veya süresi dolmuş',
    invalid_3ds_code: 'Geçersiz 3D Secure doğrulama kodu',
    card_verification_failed: 'Kart doğrulaması başarısız',
    invalid_card_type: 'Bu kart türü bankanız tarafından desteklenmiyor',
    card_restricted_by_acquirer: 'Bu kart için işlemler kısıtlı',
    card_restricted: 'Kart kullanımı kısıtlı',
    card_is_not_3ds_enrolled: "Kart 3D Secure'u desteklemiyor",
    card_is_not_3ds_v2_enrolled: "Kart 3D Secure'u desteklemiyor",
    card_is_3ds_enrolled: "Kart 3D Secure'u desteklemiyor",
    unable_to_determine_3ds_enrolment: "Kart 3D Secure'u desteklemiyor",
    card_not_3ds_enrolled: "Kart 3D Secure'u desteklemiyor",
    card_lost: 'Kartı veren kuruluş reddetti: kart kayıp olarak bildirilmiş',
    card_blocked_by_invalid_pin: 'Kart, yanlış PIN nedeniyle bloke edildi',
    card_3ds_enrolled: '3D Secure doğrulaması gerekli',
    auth_fatal_error: 'Kart yetkilendirmesi başarısız',
    auth_otp_required: 'OTP doğrulaması gerekli',
    auth_3ds_required: '3D Secure doğrulaması gerekli',
    error_during_payment: 'Ödeme işlenemedi',
    ok: 'İstek tamamlandı: başarılı ve başarısız işlemler için geçerlidir',
    approved: 'Kabul edildi',
    held_for_review: 'Doğrulama bekleniyor',
    wait_for_capture: 'Oluşturma bekleniyor',
    unable_to_reconcile: 'Mutabakat yapılamadı',
    cannot_reconcile: 'Mutabakat yapılamadı',
    dynamic_pvv_expired: 'Dinamik PVV süresi doldu',
    reconcile_required: 'Mutabakat gerekli',
    invalid_cardholder: 'Geçersiz kart sahibi',
    invalid_otp: 'Geçersiz OTP',
    auth_cvv_required: 'CVV yetkilendirmesi gerekli',
    auth_lookup_required: 'Kimlik doğrulama kontrolü gerekli',
    invalid_lookup_code: 'Geçersiz sorgulama kodu',
    no_routes_by_amount_limits: 'Ödeme reddedildi (limit aşıldı)',
    no_routes_by_turnover_limits: 'Ödeme reddedildi (limit aşıldı)',
    no_routes_by_merchant_account_limits: 'Ödeme reddedildi (limit aşıldı)',
    unable_to_cascade: 'Ödeme işlenemedi',
    no_routes_by_payment_request_options: 'Ödeme işlenemedi',
    no_routes_by_merchant_account_status: 'Ödeme işlenemedi',
    no_routes_by_payment_request_flow: 'Ödeme işlenemedi',
    no_routes_by_conditions: 'Ödeme işlenemedi',
    no_routes_by_balance: 'Ödeme işlenemedi',
    no_routes_by_history: 'Ödeme işlenemedi',
    no_available_routes: 'Ödeme işlenemedi',
    unable_to_cascade_due_to_payment_resolution: 'Ödeme işlenemedi',
    no_routes_by_status: 'Ödeme işlenemedi',
    unknown: 'Ödeme işlenemedi',
  },
  fr: {
    antifraud_error: 'Impossible de traiter le paiement',
    card_status_is_restricted_for_provider: 'L’utilisation de la carte est restreinte',
    client_auth_failed: 'L’autorisation a échoué',
    customer_is_blocked: 'La tentative de paiement est bloquée',
    card_expired: 'La date d’expiration de la carte est invalide ou expirée',
    declined_error: 'Impossible de traiter le paiement',
    duplicated_transaction: 'Impossible de traiter le paiement',
    expired: 'La session de paiement a expiré',
    functionality_is_not_permitted: 'Le paiement a été refusé par votre banque',
    connection_error: 'Impossible de traiter le paiement',
    internal_error: 'Impossible de traiter le paiement',
    gateway_internal_error: 'Impossible de traiter le paiement',
    invoke_fatal_error: 'Impossible de traiter le paiement',
    fatal_error: 'Impossible de traiter le paiement',
    general_fatal_error: 'Impossible de traiter le paiement',
    insufficient_funds: 'Fonds insuffisants sur votre carte',
    invalid_amount: 'Le montant ne peut pas être traité en raison des limites bancaires',
    invalid_card: 'La carte est invalide, clôturée ou bloquée',
    invalid_card_status: 'Restrictions de carte imposées par votre banque',
    invalid_details: 'Impossible de traiter le paiement',
    issuer_unavailable: 'Le paiement a été refusé par votre banque',
    card_usage_issuer_limit_violation:
      'Le paiement a été refusé par votre banque (limite dépassée)',
    limit_violation: 'Le paiement a été refusé par votre banque (limite dépassée)',
    lost_or_stolen_card: 'La carte est perdue ou volée',
    processing_error: 'Impossible de traiter le paiement',
    provider_fatal_error: 'Impossible de traiter le paiement',
    timeout: 'La transaction a expiré pendant le traitement',
    blocked_by_firewall: 'Paiement bloqué par le système de sécurité',
    card_customer_binding_conflict: 'La carte est déjà associée à un autre compte',
    general_decline: 'Impossible de traiter le paiement',
    invalid_cvv: 'Code CVV invalide',
    ACCESS_DENIED: 'Impossible de traiter le paiement',
    INVALID_CREDENTIALS: 'Impossible de traiter le paiement',
    INVALID_PAN: 'Numéro de carte invalide',
    INVALID_REQUEST: 'Impossible de traiter le paiement',
    TRANSACTION_NOT_FOUND: 'Impossible de traiter le paiement',
    card_is_lost: 'Refusé par l’émetteur : carte signalée comme perdue',
    card_is_stolen: 'Refusé par l’émetteur : carte signalée comme volée',
    card_status_is_restricted: 'L’utilisation de la carte est restreinte',
    card_usage_frequency_limit_violation:
      'Le paiement a été refusé par votre banque (limite dépassée)',
    fatal_card_expired: 'La date d’expiration de la carte est invalide ou expirée',
    fatal_decline: 'Impossible de traiter le paiement',
    fatal_timeout: 'Impossible de traiter le paiement',
    contact_issuer: 'Le paiement a été refusé par votre banque',
    issuer_decline: 'Le paiement a été refusé par votre banque',
    pin_tries_limit_was_reached: 'Nombre de tentatives de saisie du PIN dépassé',
    provider_error: 'Impossible de traiter le paiement',
    fatal_issuer_unavailable: 'Le paiement a été refusé par votre banque',
    invalid_account: 'Impossible de traiter le paiement',
    INVALID_TOKEN: 'Impossible de traiter le paiement',
    error: 'Impossible de traiter le paiement',
    invalid_expire_date: 'La date d’expiration de la carte est invalide ou expirée',
    invalid_3ds_code: 'Code de vérification 3D Secure invalide',
    card_verification_failed: 'La vérification de la carte a échoué',
    invalid_card_type: 'Ce type de carte n’est pas pris en charge par votre banque',
    card_restricted_by_acquirer: 'Les transactions avec cette carte sont restreintes',
    card_restricted: 'L’utilisation de la carte est restreinte',
    card_is_not_3ds_enrolled: 'La carte ne prend pas en charge 3D Secure',
    card_is_not_3ds_v2_enrolled: 'La carte ne prend pas en charge 3D Secure',
    card_is_3ds_enrolled: 'La carte ne prend pas en charge 3D Secure',
    unable_to_determine_3ds_enrolment: 'La carte ne prend pas en charge 3D Secure',
    card_not_3ds_enrolled: 'La carte ne prend pas en charge 3D Secure',
    card_lost: 'Refusé par l’émetteur : carte signalée comme perdue',
    card_blocked_by_invalid_pin: 'Carte bloquée en raison d’un PIN incorrect',
    card_3ds_enrolled: 'Vérification 3D Secure requise',
    auth_fatal_error: 'L’autorisation de la carte a échoué',
    auth_otp_required: 'Vérification OTP requise',
    auth_3ds_required: 'Vérification 3D Secure requise',
    error_during_payment: 'Impossible de traiter le paiement',
    ok: 'Demande terminée : s’applique aux transactions réussies et échouées',
    approved: 'Accepté',
    held_for_review: 'Vérification en attente',
    wait_for_capture: 'En attente de création',
    unable_to_reconcile: 'Impossible de rapprocher',
    cannot_reconcile: 'Impossible de rapprocher',
    dynamic_pvv_expired: 'Le PVV dynamique a expiré',
    reconcile_required: 'Rapprochement requis',
    invalid_cardholder: 'Titulaire de carte invalide',
    invalid_otp: 'OTP invalide',
    auth_cvv_required: 'Autorisation CVV requise',
    auth_lookup_required: 'Vérification d’authentification requise',
    invalid_lookup_code: 'Code de recherche invalide',
    no_routes_by_amount_limits: 'Le paiement a été refusé (limite dépassée)',
    no_routes_by_turnover_limits: 'Le paiement a été refusé (limite dépassée)',
    no_routes_by_merchant_account_limits: 'Le paiement a été refusé (limite dépassée)',
    unable_to_cascade: 'Impossible de traiter le paiement',
    no_routes_by_payment_request_options: 'Impossible de traiter le paiement',
    no_routes_by_merchant_account_status: 'Impossible de traiter le paiement',
    no_routes_by_payment_request_flow: 'Impossible de traiter le paiement',
    no_routes_by_conditions: 'Impossible de traiter le paiement',
    no_routes_by_balance: 'Impossible de traiter le paiement',
    no_routes_by_history: 'Impossible de traiter le paiement',
    no_available_routes: 'Impossible de traiter le paiement',
    unable_to_cascade_due_to_payment_resolution: 'Impossible de traiter le paiement',
    no_routes_by_status: 'Impossible de traiter le paiement',
    unknown: 'Impossible de traiter le paiement',
  },
  it: {
    antifraud_error: 'Impossibile elaborare il pagamento',
    card_status_is_restricted_for_provider: 'L’uso della carta è limitato',
    client_auth_failed: 'Autorizzazione non riuscita',
    customer_is_blocked: 'Il tentativo di pagamento è bloccato',
    card_expired: 'La data di scadenza della carta non è valida o è scaduta',
    declined_error: 'Impossibile elaborare il pagamento',
    duplicated_transaction: 'Impossibile elaborare il pagamento',
    expired: 'La sessione di pagamento è scaduta',
    functionality_is_not_permitted: 'Il pagamento è stato rifiutato dalla tua banca',
    connection_error: 'Impossibile elaborare il pagamento',
    internal_error: 'Impossibile elaborare il pagamento',
    gateway_internal_error: 'Impossibile elaborare il pagamento',
    invoke_fatal_error: 'Impossibile elaborare il pagamento',
    fatal_error: 'Impossibile elaborare il pagamento',
    general_fatal_error: 'Impossibile elaborare il pagamento',
    insufficient_funds: 'Fondi insufficienti sulla tua carta',
    invalid_amount: 'L’importo non può essere elaborato a causa dei limiti bancari',
    invalid_card: 'La carta non è valida, è chiusa o bloccata',
    invalid_card_status: 'Restrizioni della carta imposte dalla tua banca',
    invalid_details: 'Impossibile elaborare il pagamento',
    issuer_unavailable: 'Il pagamento è stato rifiutato dalla tua banca',
    card_usage_issuer_limit_violation:
      'Il pagamento è stato rifiutato dalla tua banca (limite superato)',
    limit_violation: 'Il pagamento è stato rifiutato dalla tua banca (limite superato)',
    lost_or_stolen_card: 'La carta è smarrita o rubata',
    processing_error: 'Impossibile elaborare il pagamento',
    provider_fatal_error: 'Impossibile elaborare il pagamento',
    timeout: 'La transazione è scaduta durante l’elaborazione',
    blocked_by_firewall: 'Pagamento bloccato dal sistema di sicurezza',
    card_customer_binding_conflict: 'La carta è già associata a un altro account',
    general_decline: 'Impossibile elaborare il pagamento',
    invalid_cvv: 'Codice CVV non valido',
    ACCESS_DENIED: 'Impossibile elaborare il pagamento',
    INVALID_CREDENTIALS: 'Impossibile elaborare il pagamento',
    INVALID_PAN: 'Numero di carta non valido',
    INVALID_REQUEST: 'Impossibile elaborare il pagamento',
    TRANSACTION_NOT_FOUND: 'Impossibile elaborare il pagamento',
    card_is_lost: 'Rifiutato dall’emittente: carta segnalata come smarrita',
    card_is_stolen: 'Rifiutato dall’emittente: carta segnalata come rubata',
    card_status_is_restricted: 'L’uso della carta è limitato',
    card_usage_frequency_limit_violation:
      'Il pagamento è stato rifiutato dalla tua banca (limite superato)',
    fatal_card_expired: 'La data di scadenza della carta non è valida o è scaduta',
    fatal_decline: 'Impossibile elaborare il pagamento',
    fatal_timeout: 'Impossibile elaborare il pagamento',
    contact_issuer: 'Il pagamento è stato rifiutato dalla tua banca',
    issuer_decline: 'Il pagamento è stato rifiutato dalla tua banca',
    pin_tries_limit_was_reached: 'Numero di tentativi di inserimento PIN superato',
    provider_error: 'Impossibile elaborare il pagamento',
    fatal_issuer_unavailable: 'Il pagamento è stato rifiutato dalla tua banca',
    invalid_account: 'Impossibile elaborare il pagamento',
    INVALID_TOKEN: 'Impossibile elaborare il pagamento',
    error: 'Impossibile elaborare il pagamento',
    invalid_expire_date: 'La data di scadenza della carta non è valida o è scaduta',
    invalid_3ds_code: 'Codice di verifica 3D Secure non valido',
    card_verification_failed: 'Verifica della carta non riuscita',
    invalid_card_type: 'Questo tipo di carta non è supportato dalla tua banca',
    card_restricted_by_acquirer: 'Le transazioni per questa carta sono limitate',
    card_restricted: 'L’uso della carta è limitato',
    card_is_not_3ds_enrolled: 'La carta non supporta 3D Secure',
    card_is_not_3ds_v2_enrolled: 'La carta non supporta 3D Secure',
    card_is_3ds_enrolled: 'La carta non supporta 3D Secure',
    unable_to_determine_3ds_enrolment: 'La carta non supporta 3D Secure',
    card_not_3ds_enrolled: 'La carta non supporta 3D Secure',
    card_lost: 'Rifiutato dall’emittente: carta segnalata come smarrita',
    card_blocked_by_invalid_pin: 'Carta bloccata a causa di PIN errato',
    card_3ds_enrolled: 'Verifica 3D Secure richiesta',
    auth_fatal_error: 'Autorizzazione della carta non riuscita',
    auth_otp_required: 'Verifica OTP richiesta',
    auth_3ds_required: 'Verifica 3D Secure richiesta',
    error_during_payment: 'Impossibile elaborare il pagamento',
    ok: 'Richiesta completata: si applica alle transazioni riuscite e non riuscite',
    approved: 'Accettato',
    held_for_review: 'Verifica in sospeso',
    wait_for_capture: 'In attesa di creazione',
    unable_to_reconcile: 'Impossibile riconciliare',
    cannot_reconcile: 'Impossibile riconciliare',
    dynamic_pvv_expired: 'Il PVV dinamico è scaduto',
    reconcile_required: 'Riconciliazione richiesta',
    invalid_cardholder: 'Titolare della carta non valido',
    invalid_otp: 'OTP non valido',
    auth_cvv_required: 'Autorizzazione CVV richiesta',
    auth_lookup_required: 'Verifica di autenticazione richiesta',
    invalid_lookup_code: 'Codice di ricerca non valido',
    no_routes_by_amount_limits: 'Il pagamento è stato rifiutato (limite superato)',
    no_routes_by_turnover_limits: 'Il pagamento è stato rifiutato (limite superato)',
    no_routes_by_merchant_account_limits: 'Il pagamento è stato rifiutato (limite superato)',
    unable_to_cascade: 'Impossibile elaborare il pagamento',
    no_routes_by_payment_request_options: 'Impossibile elaborare il pagamento',
    no_routes_by_merchant_account_status: 'Impossibile elaborare il pagamento',
    no_routes_by_payment_request_flow: 'Impossibile elaborare il pagamento',
    no_routes_by_conditions: 'Impossibile elaborare il pagamento',
    no_routes_by_balance: 'Impossibile elaborare il pagamento',
    no_routes_by_history: 'Impossibile elaborare il pagamento',
    no_available_routes: 'Impossibile elaborare il pagamento',
    unable_to_cascade_due_to_payment_resolution: 'Impossibile elaborare il pagamento',
    no_routes_by_status: 'Impossibile elaborare il pagamento',
    unknown: 'Impossibile elaborare il pagamento',
  },
  az: {
    antifraud_error: 'Ödənişi emal etmək mümkün olmadı',
    card_status_is_restricted_for_provider: 'Kartdan istifadə məhdudlaşdırılıb',
    client_auth_failed: 'Avtorizasiya uğursuz oldu',
    customer_is_blocked: 'Ödəniş cəhdi bloklanıb',
    card_expired: 'Kartın son istifadə tarixi yanlışdır və ya bitib',
    declined_error: 'Ödənişi emal etmək mümkün olmadı',
    duplicated_transaction: 'Ödənişi emal etmək mümkün olmadı',
    expired: 'Ödəniş sessiyasının müddəti bitib',
    functionality_is_not_permitted: 'Ödəniş bankınız tərəfindən rədd edildi',
    connection_error: 'Ödənişi emal etmək mümkün olmadı',
    internal_error: 'Ödənişi emal etmək mümkün olmadı',
    gateway_internal_error: 'Ödənişi emal etmək mümkün olmadı',
    invoke_fatal_error: 'Ödənişi emal etmək mümkün olmadı',
    fatal_error: 'Ödənişi emal etmək mümkün olmadı',
    general_fatal_error: 'Ödənişi emal etmək mümkün olmadı',
    insufficient_funds: 'Kartınızda kifayət qədər vəsait yoxdur',
    invalid_amount: 'Məbləğ bank limitlərinə görə emal edilə bilmir',
    invalid_card: 'Kart etibarsızdır, bağlanıb və ya bloklanıb',
    invalid_card_status: 'Bankınız tərəfindən kart məhdudiyyətləri tətbiq edilib',
    invalid_details: 'Ödənişi emal etmək mümkün olmadı',
    issuer_unavailable: 'Ödəniş bankınız tərəfindən rədd edildi',
    card_usage_issuer_limit_violation: 'Ödəniş bankınız tərəfindən rədd edildi (limit aşıldı)',
    limit_violation: 'Ödəniş bankınız tərəfindən rədd edildi (limit aşıldı)',
    lost_or_stolen_card: 'Kart itirilib və ya oğurlanıb',
    processing_error: 'Ödənişi emal etmək mümkün olmadı',
    provider_fatal_error: 'Ödənişi emal etmək mümkün olmadı',
    timeout: 'Tranzaksiya emal zamanı vaxt aşımına uğradı',
    blocked_by_firewall: 'Ödəniş təhlükəsizlik sistemi tərəfindən bloklanıb',
    card_customer_binding_conflict: 'Kart artıq başqa hesaba bağlanıb',
    general_decline: 'Ödənişi emal etmək mümkün olmadı',
    invalid_cvv: 'Yanlış CVV kodu',
    ACCESS_DENIED: 'Ödənişi emal etmək mümkün olmadı',
    INVALID_CREDENTIALS: 'Ödənişi emal etmək mümkün olmadı',
    INVALID_PAN: 'Yanlış kart nömrəsi',
    INVALID_REQUEST: 'Ödənişi emal etmək mümkün olmadı',
    TRANSACTION_NOT_FOUND: 'Ödənişi emal etmək mümkün olmadı',
    card_is_lost: 'Emitent rədd etdi: kart itirilmiş kimi bildirilib',
    card_is_stolen: 'Emitent rədd etdi: kart oğurlanmış kimi bildirilib',
    card_status_is_restricted: 'Kartdan istifadə məhdudlaşdırılıb',
    card_usage_frequency_limit_violation: 'Ödəniş bankınız tərəfindən rədd edildi (limit aşıldı)',
    fatal_card_expired: 'Kartın son istifadə tarixi yanlışdır və ya bitib',
    fatal_decline: 'Ödənişi emal etmək mümkün olmadı',
    fatal_timeout: 'Ödənişi emal etmək mümkün olmadı',
    contact_issuer: 'Ödəniş bankınız tərəfindən rədd edildi',
    issuer_decline: 'Ödəniş bankınız tərəfindən rədd edildi',
    pin_tries_limit_was_reached: 'PIN daxil etmə cəhdlərinin sayı aşıldı',
    provider_error: 'Ödənişi emal etmək mümkün olmadı',
    fatal_issuer_unavailable: 'Ödəniş bankınız tərəfindən rədd edildi',
    invalid_account: 'Ödənişi emal etmək mümkün olmadı',
    INVALID_TOKEN: 'Ödənişi emal etmək mümkün olmadı',
    error: 'Ödənişi emal etmək mümkün olmadı',
    invalid_expire_date: 'Kartın son istifadə tarixi yanlışdır və ya bitib',
    invalid_3ds_code: 'Yanlış 3D Secure təsdiqləmə kodu',
    card_verification_failed: 'Kartın yoxlanılması uğursuz oldu',
    invalid_card_type: 'Bu kart növü bankınız tərəfindən dəstəklənmir',
    card_restricted_by_acquirer: 'Bu kart üzrə tranzaksiyalar məhdudlaşdırılıb',
    card_restricted: 'Kartdan istifadə məhdudlaşdırılıb',
    card_is_not_3ds_enrolled: 'Kart 3D Secure-u dəstəkləmir',
    card_is_not_3ds_v2_enrolled: 'Kart 3D Secure-u dəstəkləmir',
    card_is_3ds_enrolled: 'Kart 3D Secure-u dəstəkləmir',
    unable_to_determine_3ds_enrolment: 'Kart 3D Secure-u dəstəkləmir',
    card_not_3ds_enrolled: 'Kart 3D Secure-u dəstəkləmir',
    card_lost: 'Emitent rədd etdi: kart itirilmiş kimi bildirilib',
    card_blocked_by_invalid_pin: 'Kart yanlış PIN səbəbindən bloklanıb',
    card_3ds_enrolled: '3D Secure təsdiqləməsi tələb olunur',
    auth_fatal_error: 'Kart avtorizasiyası uğursuz oldu',
    auth_otp_required: 'OTP təsdiqləməsi tələb olunur',
    auth_3ds_required: '3D Secure təsdiqləməsi tələb olunur',
    error_during_payment: 'Ödənişi emal etmək mümkün olmadı',
    ok: 'Sorğu tamamlandı: uğurlu və uğursuz tranzaksiyalara aiddir',
    approved: 'Qəbul edildi',
    held_for_review: 'Yoxlama gözlənilir',
    wait_for_capture: 'Yaradılma gözlənilir',
    unable_to_reconcile: 'Uzlaşdırmaq mümkün olmadı',
    cannot_reconcile: 'Uzlaşdırmaq mümkün olmadı',
    dynamic_pvv_expired: 'Dinamik PVV-nin müddəti bitib',
    reconcile_required: 'Uzlaşdırma tələb olunur',
    invalid_cardholder: 'Yanlış kart sahibi',
    invalid_otp: 'Yanlış OTP',
    auth_cvv_required: 'CVV avtorizasiyası tələb olunur',
    auth_lookup_required: 'Autentifikasiya yoxlaması tələb olunur',
    invalid_lookup_code: 'Yanlış axtarış kodu',
    no_routes_by_amount_limits: 'Ödəniş rədd edildi (limit aşıldı)',
    no_routes_by_turnover_limits: 'Ödəniş rədd edildi (limit aşıldı)',
    no_routes_by_merchant_account_limits: 'Ödəniş rədd edildi (limit aşıldı)',
    unable_to_cascade: 'Ödənişi emal etmək mümkün olmadı',
    no_routes_by_payment_request_options: 'Ödənişi emal etmək mümkün olmadı',
    no_routes_by_merchant_account_status: 'Ödənişi emal etmək mümkün olmadı',
    no_routes_by_payment_request_flow: 'Ödənişi emal etmək mümkün olmadı',
    no_routes_by_conditions: 'Ödənişi emal etmək mümkün olmadı',
    no_routes_by_balance: 'Ödənişi emal etmək mümkün olmadı',
    no_routes_by_history: 'Ödənişi emal etmək mümkün olmadı',
    no_available_routes: 'Ödənişi emal etmək mümkün olmadı',
    unable_to_cascade_due_to_payment_resolution: 'Ödənişi emal etmək mümkün olmadı',
    no_routes_by_status: 'Ödənişi emal etmək mümkün olmadı',
    unknown: 'Ödənişi emal etmək mümkün olmadı',
  },
  pl: {
    antifraud_error: 'Nie można przetworzyć płatności',
    card_status_is_restricted_for_provider: 'Użycie karty jest ograniczone',
    client_auth_failed: 'Autoryzacja nie powiodła się',
    customer_is_blocked: 'Próba płatności została zablokowana',
    card_expired: 'Data ważności karty jest nieprawidłowa lub wygasła',
    declined_error: 'Nie można przetworzyć płatności',
    duplicated_transaction: 'Nie można przetworzyć płatności',
    expired: 'Sesja płatności wygasła',
    functionality_is_not_permitted: 'Płatność została odrzucona przez Twój bank',
    connection_error: 'Nie można przetworzyć płatności',
    internal_error: 'Nie można przetworzyć płatności',
    gateway_internal_error: 'Nie można przetworzyć płatności',
    invoke_fatal_error: 'Nie można przetworzyć płatności',
    fatal_error: 'Nie można przetworzyć płatności',
    general_fatal_error: 'Nie można przetworzyć płatności',
    insufficient_funds: 'Niewystarczające środki na karcie',
    invalid_amount: 'Kwota nie może zostać przetworzona z powodu limitów banku',
    invalid_card: 'Karta jest nieprawidłowa, zamknięta lub zablokowana',
    invalid_card_status: 'Ograniczenia karty nałożone przez Twój bank',
    invalid_details: 'Nie można przetworzyć płatności',
    issuer_unavailable: 'Płatność została odrzucona przez Twój bank',
    card_usage_issuer_limit_violation:
      'Płatność została odrzucona przez Twój bank (limit przekroczony)',
    limit_violation: 'Płatność została odrzucona przez Twój bank (limit przekroczony)',
    lost_or_stolen_card: 'Karta została zgubiona lub skradziona',
    processing_error: 'Nie można przetworzyć płatności',
    provider_fatal_error: 'Nie można przetworzyć płatności',
    timeout: 'Transakcja przekroczyła limit czasu podczas przetwarzania',
    blocked_by_firewall: 'Płatność zablokowana przez system bezpieczeństwa',
    card_customer_binding_conflict: 'Karta jest już powiązana z innym kontem',
    general_decline: 'Nie można przetworzyć płatności',
    invalid_cvv: 'Nieprawidłowy kod CVV',
    ACCESS_DENIED: 'Nie można przetworzyć płatności',
    INVALID_CREDENTIALS: 'Nie można przetworzyć płatności',
    INVALID_PAN: 'Nieprawidłowy numer karty',
    INVALID_REQUEST: 'Nie można przetworzyć płatności',
    TRANSACTION_NOT_FOUND: 'Nie można przetworzyć płatności',
    card_is_lost: 'Odrzucono przez wydawcę: karta zgłoszona jako zgubiona',
    card_is_stolen: 'Odrzucono przez wydawcę: karta zgłoszona jako skradziona',
    card_status_is_restricted: 'Użycie karty jest ograniczone',
    card_usage_frequency_limit_violation:
      'Płatność została odrzucona przez Twój bank (limit przekroczony)',
    fatal_card_expired: 'Data ważności karty jest nieprawidłowa lub wygasła',
    fatal_decline: 'Nie można przetworzyć płatności',
    fatal_timeout: 'Nie można przetworzyć płatności',
    contact_issuer: 'Płatność została odrzucona przez Twój bank',
    issuer_decline: 'Płatność została odrzucona przez Twój bank',
    pin_tries_limit_was_reached: 'Przekroczono liczbę prób wprowadzenia PIN-u',
    provider_error: 'Nie można przetworzyć płatności',
    fatal_issuer_unavailable: 'Płatność została odrzucona przez Twój bank',
    invalid_account: 'Nie można przetworzyć płatności',
    INVALID_TOKEN: 'Nie można przetworzyć płatności',
    error: 'Nie można przetworzyć płatności',
    invalid_expire_date: 'Data ważności karty jest nieprawidłowa lub wygasła',
    invalid_3ds_code: 'Nieprawidłowy kod weryfikacyjny 3D Secure',
    card_verification_failed: 'Weryfikacja karty nie powiodła się',
    invalid_card_type: 'Ten typ karty nie jest obsługiwany przez Twój bank',
    card_restricted_by_acquirer: 'Transakcje dla tej karty są ograniczone',
    card_restricted: 'Użycie karty jest ograniczone',
    card_is_not_3ds_enrolled: 'Karta nie obsługuje 3D Secure',
    card_is_not_3ds_v2_enrolled: 'Karta nie obsługuje 3D Secure',
    card_is_3ds_enrolled: 'Karta nie obsługuje 3D Secure',
    unable_to_determine_3ds_enrolment: 'Karta nie obsługuje 3D Secure',
    card_not_3ds_enrolled: 'Karta nie obsługuje 3D Secure',
    card_lost: 'Odrzucono przez wydawcę: karta zgłoszona jako zgubiona',
    card_blocked_by_invalid_pin: 'Karta zablokowana z powodu nieprawidłowego PIN-u',
    card_3ds_enrolled: 'Wymagana weryfikacja 3D Secure',
    auth_fatal_error: 'Autoryzacja karty nie powiodła się',
    auth_otp_required: 'Wymagana weryfikacja OTP',
    auth_3ds_required: 'Wymagana weryfikacja 3D Secure',
    error_during_payment: 'Nie można przetworzyć płatności',
    ok: 'Żądanie zakończone: dotyczy transakcji udanych i nieudanych',
    approved: 'Zaakceptowano',
    held_for_review: 'Oczekuje na weryfikację',
    wait_for_capture: 'Oczekuje na utworzenie',
    unable_to_reconcile: 'Nie można uzgodnić',
    cannot_reconcile: 'Nie można uzgodnić',
    dynamic_pvv_expired: 'Dynamiczny PVV wygasł',
    reconcile_required: 'Wymagane uzgodnienie',
    invalid_cardholder: 'Nieprawidłowy posiadacz karty',
    invalid_otp: 'Nieprawidłowy OTP',
    auth_cvv_required: 'Wymagana autoryzacja CVV',
    auth_lookup_required: 'Wymagana kontrola uwierzytelnienia',
    invalid_lookup_code: 'Nieprawidłowy kod wyszukiwania',
    no_routes_by_amount_limits: 'Płatność została odrzucona (limit przekroczony)',
    no_routes_by_turnover_limits: 'Płatność została odrzucona (limit przekroczony)',
    no_routes_by_merchant_account_limits: 'Płatność została odrzucona (limit przekroczony)',
    unable_to_cascade: 'Nie można przetworzyć płatności',
    no_routes_by_payment_request_options: 'Nie można przetworzyć płatności',
    no_routes_by_merchant_account_status: 'Nie można przetworzyć płatności',
    no_routes_by_payment_request_flow: 'Nie można przetworzyć płatności',
    no_routes_by_conditions: 'Nie można przetworzyć płatności',
    no_routes_by_balance: 'Nie można przetworzyć płatności',
    no_routes_by_history: 'Nie można przetworzyć płatności',
    no_available_routes: 'Nie można przetworzyć płatności',
    unable_to_cascade_due_to_payment_resolution: 'Nie można przetworzyć płatności',
    no_routes_by_status: 'Nie można przetworzyć płatności',
    unknown: 'Nie można przetworzyć płatności',
  },
  ud: {
    antifraud_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    card_status_is_restricted_for_provider: 'کارڈ کے استعمال پر پابندی ہے',
    client_auth_failed: 'اجازت نامہ ناکام ہو گیا',
    customer_is_blocked: 'ادائیگی کی کوشش بلاک کر دی گئی ہے',
    card_expired: 'کارڈ کی میعاد ختم ہونے کی تاریخ غلط ہے یا ختم ہو چکی ہے',
    declined_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    duplicated_transaction: 'ادائیگی پر کارروائی نہیں ہو سکی',
    expired: 'ادائیگی کا سیشن ختم ہو چکا ہے',
    functionality_is_not_permitted: 'آپ کے بینک نے ادائیگی مسترد کر دی',
    connection_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    internal_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    gateway_internal_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    invoke_fatal_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    fatal_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    general_fatal_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    insufficient_funds: 'آپ کے کارڈ میں ناکافی فنڈز ہیں',
    invalid_amount: 'بینک کی حدود کی وجہ سے رقم پر کارروائی نہیں ہو سکتی',
    invalid_card: 'کارڈ غلط، بند یا بلاک ہے',
    invalid_card_status: 'آپ کے بینک کی طرف سے کارڈ پر پابندیاں عائد ہیں',
    invalid_details: 'ادائیگی پر کارروائی نہیں ہو سکی',
    issuer_unavailable: 'آپ کے بینک نے ادائیگی مسترد کر دی',
    card_usage_issuer_limit_violation: 'آپ کے بینک نے ادائیگی مسترد کر دی (حد سے تجاوز ہو گیا)',
    limit_violation: 'آپ کے بینک نے ادائیگی مسترد کر دی (حد سے تجاوز ہو گیا)',
    lost_or_stolen_card: 'کارڈ گم یا چوری ہو گیا ہے',
    processing_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    provider_fatal_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    timeout: 'کارروائی کے دوران ٹرانزیکشن کا وقت ختم ہو گیا',
    blocked_by_firewall: 'ادائیگی سیکیورٹی سسٹم نے بلاک کر دی',
    card_customer_binding_conflict: 'یہ کارڈ پہلے سے کسی دوسرے اکاؤنٹ سے منسلک ہے',
    general_decline: 'ادائیگی پر کارروائی نہیں ہو سکی',
    invalid_cvv: 'غلط CVV کوڈ',
    ACCESS_DENIED: 'ادائیگی پر کارروائی نہیں ہو سکی',
    INVALID_CREDENTIALS: 'ادائیگی پر کارروائی نہیں ہو سکی',
    INVALID_PAN: 'غلط کارڈ نمبر',
    INVALID_REQUEST: 'ادائیگی پر کارروائی نہیں ہو سکی',
    TRANSACTION_NOT_FOUND: 'ادائیگی پر کارروائی نہیں ہو سکی',
    card_is_lost: 'جاری کنندہ نے مسترد کیا: کارڈ گم ہونے کی اطلاع ہے',
    card_is_stolen: 'جاری کنندہ نے مسترد کیا: کارڈ چوری ہونے کی اطلاع ہے',
    card_status_is_restricted: 'کارڈ کے استعمال پر پابندی ہے',
    card_usage_frequency_limit_violation: 'آپ کے بینک نے ادائیگی مسترد کر دی (حد سے تجاوز ہو گیا)',
    fatal_card_expired: 'کارڈ کی میعاد ختم ہونے کی تاریخ غلط ہے یا ختم ہو چکی ہے',
    fatal_decline: 'ادائیگی پر کارروائی نہیں ہو سکی',
    fatal_timeout: 'ادائیگی پر کارروائی نہیں ہو سکی',
    contact_issuer: 'آپ کے بینک نے ادائیگی مسترد کر دی',
    issuer_decline: 'آپ کے بینک نے ادائیگی مسترد کر دی',
    pin_tries_limit_was_reached: 'PIN درج کرنے کی کوششوں کی حد سے تجاوز ہو گیا',
    provider_error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    fatal_issuer_unavailable: 'آپ کے بینک نے ادائیگی مسترد کر دی',
    invalid_account: 'ادائیگی پر کارروائی نہیں ہو سکی',
    INVALID_TOKEN: 'ادائیگی پر کارروائی نہیں ہو سکی',
    error: 'ادائیگی پر کارروائی نہیں ہو سکی',
    invalid_expire_date: 'کارڈ کی میعاد ختم ہونے کی تاریخ غلط ہے یا ختم ہو چکی ہے',
    invalid_3ds_code: 'غلط 3D Secure تصدیقی کوڈ',
    card_verification_failed: 'کارڈ کی تصدیق ناکام ہو گئی',
    invalid_card_type: 'آپ کا بینک اس قسم کے کارڈ کو سپورٹ نہیں کرتا',
    card_restricted_by_acquirer: 'اس کارڈ کے لیے ٹرانزیکشنز محدود ہیں',
    card_restricted: 'کارڈ کے استعمال پر پابندی ہے',
    card_is_not_3ds_enrolled: 'کارڈ 3D Secure کو سپورٹ نہیں کرتا',
    card_is_not_3ds_v2_enrolled: 'کارڈ 3D Secure کو سپورٹ نہیں کرتا',
    card_is_3ds_enrolled: 'کارڈ 3D Secure کو سپورٹ نہیں کرتا',
    unable_to_determine_3ds_enrolment: 'کارڈ 3D Secure کو سپورٹ نہیں کرتا',
    card_not_3ds_enrolled: 'کارڈ 3D Secure کو سپورٹ نہیں کرتا',
    card_lost: 'جاری کنندہ نے مسترد کیا: کارڈ گم ہونے کی اطلاع ہے',
    card_blocked_by_invalid_pin: 'غلط PIN کی وجہ سے کارڈ بلاک ہو گیا',
    card_3ds_enrolled: '3D Secure تصدیق درکار ہے',
    auth_fatal_error: 'کارڈ کی اجازت دہی ناکام ہو گئی',
    auth_otp_required: 'OTP تصدیق درکار ہے',
    auth_3ds_required: '3D Secure تصدیق درکار ہے',
    error_during_payment: 'ادائیگی پر کارروائی نہیں ہو سکی',
    ok: 'درخواست مکمل ہو گئی: کامیاب اور ناکام ٹرانزیکشنز پر لاگو ہوتا ہے',
    approved: 'قبول کر لیا گیا',
    held_for_review: 'تصدیق زیر التوا ہے',
    wait_for_capture: 'تخلیق کا انتظار ہے',
    unable_to_reconcile: 'مطابقت ممکن نہیں',
    cannot_reconcile: 'مطابقت ممکن نہیں',
    dynamic_pvv_expired: 'ڈائنامک PVV کی میعاد ختم ہو چکی ہے',
    reconcile_required: 'مطابقت درکار ہے',
    invalid_cardholder: 'غلط کارڈ ہولڈر',
    invalid_otp: 'غلط OTP',
    auth_cvv_required: 'CVV اجازت درکار ہے',
    auth_lookup_required: 'تصدیق کی جانچ درکار ہے',
    invalid_lookup_code: 'غلط تلاش کوڈ',
    no_routes_by_amount_limits: 'ادائیگی مسترد کر دی گئی (حد سے تجاوز ہو گیا)',
    no_routes_by_turnover_limits: 'ادائیگی مسترد کر دی گئی (حد سے تجاوز ہو گیا)',
    no_routes_by_merchant_account_limits: 'ادائیگی مسترد کر دی گئی (حد سے تجاوز ہو گیا)',
    unable_to_cascade: 'ادائیگی پر کارروائی نہیں ہو سکی',
    no_routes_by_payment_request_options: 'ادائیگی پر کارروائی نہیں ہو سکی',
    no_routes_by_merchant_account_status: 'ادائیگی پر کارروائی نہیں ہو سکی',
    no_routes_by_payment_request_flow: 'ادائیگی پر کارروائی نہیں ہو سکی',
    no_routes_by_conditions: 'ادائیگی پر کارروائی نہیں ہو سکی',
    no_routes_by_balance: 'ادائیگی پر کارروائی نہیں ہو سکی',
    no_routes_by_history: 'ادائیگی پر کارروائی نہیں ہو سکی',
    no_available_routes: 'ادائیگی پر کارروائی نہیں ہو سکی',
    unable_to_cascade_due_to_payment_resolution: 'ادائیگی پر کارروائی نہیں ہو سکی',
    no_routes_by_status: 'ادائیگی پر کارروائی نہیں ہو سکی',
    unknown: 'ادائیگی پر کارروائی نہیں ہو سکی',
  },
  ja: {
    antifraud_error: '支払いを処理できませんでした',
    card_status_is_restricted_for_provider: 'カードの利用が制限されています',
    client_auth_failed: '認証に失敗しました',
    customer_is_blocked: '支払い試行がブロックされました',
    card_expired: 'カードの有効期限が無効または期限切れです',
    declined_error: '支払いを処理できませんでした',
    duplicated_transaction: '支払いを処理できませんでした',
    expired: '支払いセッションの有効期限が切れました',
    functionality_is_not_permitted: 'ご利用の銀行により支払いが拒否されました',
    connection_error: '支払いを処理できませんでした',
    internal_error: '支払いを処理できませんでした',
    gateway_internal_error: '支払いを処理できませんでした',
    invoke_fatal_error: '支払いを処理できませんでした',
    fatal_error: '支払いを処理できませんでした',
    general_fatal_error: '支払いを処理できませんでした',
    insufficient_funds: 'カードの残高が不足しています',
    invalid_amount: '銀行の制限により金額を処理できません',
    invalid_card: 'カードが無効、解約済み、またはブロックされています',
    invalid_card_status: 'ご利用の銀行によりカード制限が設定されています',
    invalid_details: '支払いを処理できませんでした',
    issuer_unavailable: 'ご利用の銀行により支払いが拒否されました',
    card_usage_issuer_limit_violation: 'ご利用の銀行により支払いが拒否されました（限度額超過）',
    limit_violation: 'ご利用の銀行により支払いが拒否されました（限度額超過）',
    lost_or_stolen_card: 'カードは紛失または盗難として登録されています',
    processing_error: '支払いを処理できませんでした',
    provider_fatal_error: '支払いを処理できませんでした',
    timeout: '処理中に取引がタイムアウトしました',
    blocked_by_firewall: '支払いはセキュリティシステムによりブロックされました',
    card_customer_binding_conflict: 'このカードは既に別のアカウントに登録されています',
    general_decline: '支払いを処理できませんでした',
    invalid_cvv: '無効なCVVコード',
    ACCESS_DENIED: '支払いを処理できませんでした',
    INVALID_CREDENTIALS: '支払いを処理できませんでした',
    INVALID_PAN: '無効なカード番号',
    INVALID_REQUEST: '支払いを処理できませんでした',
    TRANSACTION_NOT_FOUND: '支払いを処理できませんでした',
    card_is_lost: '発行会社により拒否されました：カードは紛失として報告されています',
    card_is_stolen: '発行会社により拒否されました：カードは盗難として報告されています',
    card_status_is_restricted: 'カードの利用が制限されています',
    card_usage_frequency_limit_violation: 'ご利用の銀行により支払いが拒否されました（限度額超過）',
    fatal_card_expired: 'カードの有効期限が無効または期限切れです',
    fatal_decline: '支払いを処理できませんでした',
    fatal_timeout: '支払いを処理できませんでした',
    contact_issuer: 'ご利用の銀行により支払いが拒否されました',
    issuer_decline: 'ご利用の銀行により支払いが拒否されました',
    pin_tries_limit_was_reached: 'PIN入力試行回数を超過しました',
    provider_error: '支払いを処理できませんでした',
    fatal_issuer_unavailable: 'ご利用の銀行により支払いが拒否されました',
    invalid_account: '支払いを処理できませんでした',
    INVALID_TOKEN: '支払いを処理できませんでした',
    error: '支払いを処理できませんでした',
    invalid_expire_date: 'カードの有効期限が無効または期限切れです',
    invalid_3ds_code: '無効な3D Secure確認コード',
    card_verification_failed: 'カード確認に失敗しました',
    invalid_card_type: 'このカード種別はご利用の銀行でサポートされていません',
    card_restricted_by_acquirer: 'このカードの取引は制限されています',
    card_restricted: 'カードの利用が制限されています',
    card_is_not_3ds_enrolled: 'カードは3D Secureに対応していません',
    card_is_not_3ds_v2_enrolled: 'カードは3D Secureに対応していません',
    card_is_3ds_enrolled: 'カードは3D Secureに対応していません',
    unable_to_determine_3ds_enrolment: 'カードは3D Secureに対応していません',
    card_not_3ds_enrolled: 'カードは3D Secureに対応していません',
    card_lost: '発行会社により拒否されました：カードは紛失として報告されています',
    card_blocked_by_invalid_pin: 'PINの誤入力によりカードがブロックされました',
    card_3ds_enrolled: '3D Secure確認が必要です',
    auth_fatal_error: 'カード認証に失敗しました',
    auth_otp_required: 'OTP確認が必要です',
    auth_3ds_required: '3D Secure確認が必要です',
    error_during_payment: '支払いを処理できませんでした',
    ok: 'リクエストが完了しました：成功および失敗した取引に適用されます',
    approved: '承認済み',
    held_for_review: '確認待ち',
    wait_for_capture: '作成待ち',
    unable_to_reconcile: '照合できません',
    cannot_reconcile: '照合できません',
    dynamic_pvv_expired: 'Dynamic PVVの有効期限が切れました',
    reconcile_required: '照合が必要です',
    invalid_cardholder: '無効なカード名義人',
    invalid_otp: '無効なOTP',
    auth_cvv_required: 'CVV認証が必要です',
    auth_lookup_required: '認証チェックが必要です',
    invalid_lookup_code: '無効な検索コード',
    no_routes_by_amount_limits: '支払いが拒否されました（限度額超過）',
    no_routes_by_turnover_limits: '支払いが拒否されました（限度額超過）',
    no_routes_by_merchant_account_limits: '支払いが拒否されました（限度額超過）',
    unable_to_cascade: '支払いを処理できませんでした',
    no_routes_by_payment_request_options: '支払いを処理できませんでした',
    no_routes_by_merchant_account_status: '支払いを処理できませんでした',
    no_routes_by_payment_request_flow: '支払いを処理できませんでした',
    no_routes_by_conditions: '支払いを処理できませんでした',
    no_routes_by_balance: '支払いを処理できませんでした',
    no_routes_by_history: '支払いを処理できませんでした',
    no_available_routes: '支払いを処理できませんでした',
    unable_to_cascade_due_to_payment_resolution: '支払いを処理できませんでした',
    no_routes_by_status: '支払いを処理できませんでした',
    unknown: '支払いを処理できませんでした',
  },
  zh: {
    antifraud_error: '无法处理付款',
    card_status_is_restricted_for_provider: '银行卡使用受限',
    client_auth_failed: '授权失败',
    customer_is_blocked: '付款尝试已被阻止',
    card_expired: '银行卡有效期无效或已过期',
    declined_error: '无法处理付款',
    duplicated_transaction: '无法处理付款',
    expired: '付款会话已过期',
    functionality_is_not_permitted: '付款被您的银行拒绝',
    connection_error: '无法处理付款',
    internal_error: '无法处理付款',
    gateway_internal_error: '无法处理付款',
    invoke_fatal_error: '无法处理付款',
    fatal_error: '无法处理付款',
    general_fatal_error: '无法处理付款',
    insufficient_funds: '您的银行卡余额不足',
    invalid_amount: '由于银行限额，无法处理该金额',
    invalid_card: '银行卡无效、已关闭或已被冻结',
    invalid_card_status: '您的银行对银行卡设置了限制',
    invalid_details: '无法处理付款',
    issuer_unavailable: '付款被您的银行拒绝',
    card_usage_issuer_limit_violation: '付款被您的银行拒绝（超过限额）',
    limit_violation: '付款被您的银行拒绝（超过限额）',
    lost_or_stolen_card: '银行卡已丢失或被盗',
    processing_error: '无法处理付款',
    provider_fatal_error: '无法处理付款',
    timeout: '交易处理过程中超时',
    blocked_by_firewall: '付款被安全系统阻止',
    card_customer_binding_conflict: '该卡已绑定到其他账户',
    general_decline: '无法处理付款',
    invalid_cvv: 'CVV 码无效',
    ACCESS_DENIED: '无法处理付款',
    INVALID_CREDENTIALS: '无法处理付款',
    INVALID_PAN: '银行卡号无效',
    INVALID_REQUEST: '无法处理付款',
    TRANSACTION_NOT_FOUND: '无法处理付款',
    card_is_lost: '发卡行拒绝：银行卡已报告丢失',
    card_is_stolen: '发卡行拒绝：银行卡已报告被盗',
    card_status_is_restricted: '银行卡使用受限',
    card_usage_frequency_limit_violation: '付款被您的银行拒绝（超过限额）',
    fatal_card_expired: '银行卡有效期无效或已过期',
    fatal_decline: '无法处理付款',
    fatal_timeout: '无法处理付款',
    contact_issuer: '付款被您的银行拒绝',
    issuer_decline: '付款被您的银行拒绝',
    pin_tries_limit_was_reached: 'PIN 输入尝试次数已超限',
    provider_error: '无法处理付款',
    fatal_issuer_unavailable: '付款被您的银行拒绝',
    invalid_account: '无法处理付款',
    INVALID_TOKEN: '无法处理付款',
    error: '无法处理付款',
    invalid_expire_date: '银行卡有效期无效或已过期',
    invalid_3ds_code: '3D Secure 验证码无效',
    card_verification_failed: '银行卡验证失败',
    invalid_card_type: '您的银行不支持此银行卡类型',
    card_restricted_by_acquirer: '此银行卡的交易受限',
    card_restricted: '银行卡使用受限',
    card_is_not_3ds_enrolled: '银行卡不支持 3D Secure',
    card_is_not_3ds_v2_enrolled: '银行卡不支持 3D Secure',
    card_is_3ds_enrolled: '银行卡不支持 3D Secure',
    unable_to_determine_3ds_enrolment: '银行卡不支持 3D Secure',
    card_not_3ds_enrolled: '银行卡不支持 3D Secure',
    card_lost: '发卡行拒绝：银行卡已报告丢失',
    card_blocked_by_invalid_pin: '银行卡因 PIN 错误而被冻结',
    card_3ds_enrolled: '需要 3D Secure 验证',
    auth_fatal_error: '银行卡授权失败',
    auth_otp_required: '需要 OTP 验证',
    auth_3ds_required: '需要 3D Secure 验证',
    error_during_payment: '无法处理付款',
    ok: '请求已完成：适用于成功和失败的交易',
    approved: '已接受',
    held_for_review: '待验证',
    wait_for_capture: '等待创建',
    unable_to_reconcile: '无法对账',
    cannot_reconcile: '无法对账',
    dynamic_pvv_expired: '动态 PVV 已过期',
    reconcile_required: '需要对账',
    invalid_cardholder: '持卡人无效',
    invalid_otp: 'OTP 无效',
    auth_cvv_required: '需要 CVV 授权',
    auth_lookup_required: '需要身份验证检查',
    invalid_lookup_code: '查询代码无效',
    no_routes_by_amount_limits: '付款被拒绝（超过限额）',
    no_routes_by_turnover_limits: '付款被拒绝（超过限额）',
    no_routes_by_merchant_account_limits: '付款被拒绝（超过限额）',
    unable_to_cascade: '无法处理付款',
    no_routes_by_payment_request_options: '无法处理付款',
    no_routes_by_merchant_account_status: '无法处理付款',
    no_routes_by_payment_request_flow: '无法处理付款',
    no_routes_by_conditions: '无法处理付款',
    no_routes_by_balance: '无法处理付款',
    no_routes_by_history: '无法处理付款',
    no_available_routes: '无法处理付款',
    unable_to_cascade_due_to_payment_resolution: '无法处理付款',
    no_routes_by_status: '无法处理付款',
    unknown: '无法处理付款',
  },
  'zh-hant': {
    antifraud_error: '無法處理付款',
    card_status_is_restricted_for_provider: '卡片使用受限',
    client_auth_failed: '授權失敗',
    customer_is_blocked: '付款嘗試已被封鎖',
    card_expired: '卡片有效期限無效或已過期',
    declined_error: '無法處理付款',
    duplicated_transaction: '無法處理付款',
    expired: '付款工作階段已過期',
    functionality_is_not_permitted: '付款遭您的銀行拒絕',
    connection_error: '無法處理付款',
    internal_error: '無法處理付款',
    gateway_internal_error: '無法處理付款',
    invoke_fatal_error: '無法處理付款',
    fatal_error: '無法處理付款',
    general_fatal_error: '無法處理付款',
    insufficient_funds: '您的卡片餘額不足',
    invalid_amount: '因銀行限額，無法處理該金額',
    invalid_card: '卡片無效、已關閉或已被封鎖',
    invalid_card_status: '您的銀行對卡片設定了限制',
    invalid_details: '無法處理付款',
    issuer_unavailable: '付款遭您的銀行拒絕',
    card_usage_issuer_limit_violation: '付款遭您的銀行拒絕（超過限額）',
    limit_violation: '付款遭您的銀行拒絕（超過限額）',
    lost_or_stolen_card: '卡片已遺失或遭竊',
    processing_error: '無法處理付款',
    provider_fatal_error: '無法處理付款',
    timeout: '交易處理期間逾時',
    blocked_by_firewall: '付款遭安全系統封鎖',
    card_customer_binding_conflict: '該卡已綁定至其他帳戶',
    general_decline: '無法處理付款',
    invalid_cvv: 'CVV 碼無效',
    ACCESS_DENIED: '無法處理付款',
    INVALID_CREDENTIALS: '無法處理付款',
    INVALID_PAN: '卡號無效',
    INVALID_REQUEST: '無法處理付款',
    TRANSACTION_NOT_FOUND: '無法處理付款',
    card_is_lost: '發卡機構拒絕：卡片已通報遺失',
    card_is_stolen: '發卡機構拒絕：卡片已通報遭竊',
    card_status_is_restricted: '卡片使用受限',
    card_usage_frequency_limit_violation: '付款遭您的銀行拒絕（超過限額）',
    fatal_card_expired: '卡片有效期限無效或已過期',
    fatal_decline: '無法處理付款',
    fatal_timeout: '無法處理付款',
    contact_issuer: '付款遭您的銀行拒絕',
    issuer_decline: '付款遭您的銀行拒絕',
    pin_tries_limit_was_reached: 'PIN 輸入嘗試次數已超限',
    provider_error: '無法處理付款',
    fatal_issuer_unavailable: '付款遭您的銀行拒絕',
    invalid_account: '無法處理付款',
    INVALID_TOKEN: '無法處理付款',
    error: '無法處理付款',
    invalid_expire_date: '卡片有效期限無效或已過期',
    invalid_3ds_code: '3D Secure 驗證碼無效',
    card_verification_failed: '卡片驗證失敗',
    invalid_card_type: '您的銀行不支援此卡片類型',
    card_restricted_by_acquirer: '此卡片的交易受限',
    card_restricted: '卡片使用受限',
    card_is_not_3ds_enrolled: '卡片不支援 3D Secure',
    card_is_not_3ds_v2_enrolled: '卡片不支援 3D Secure',
    card_is_3ds_enrolled: '卡片不支援 3D Secure',
    unable_to_determine_3ds_enrolment: '卡片不支援 3D Secure',
    card_not_3ds_enrolled: '卡片不支援 3D Secure',
    card_lost: '發卡機構拒絕：卡片已通報遺失',
    card_blocked_by_invalid_pin: '卡片因 PIN 錯誤而被封鎖',
    card_3ds_enrolled: '需要 3D Secure 驗證',
    auth_fatal_error: '卡片授權失敗',
    auth_otp_required: '需要 OTP 驗證',
    auth_3ds_required: '需要 3D Secure 驗證',
    error_during_payment: '無法處理付款',
    ok: '請求已完成：適用於成功和失敗的交易',
    approved: '已接受',
    held_for_review: '待驗證',
    wait_for_capture: '等待建立',
    unable_to_reconcile: '無法對帳',
    cannot_reconcile: '無法對帳',
    dynamic_pvv_expired: '動態 PVV 已過期',
    reconcile_required: '需要對帳',
    invalid_cardholder: '持卡人無效',
    invalid_otp: 'OTP 無效',
    auth_cvv_required: '需要 CVV 授權',
    auth_lookup_required: '需要身分驗證檢查',
    invalid_lookup_code: '查詢代碼無效',
    no_routes_by_amount_limits: '付款遭拒絕（超過限額）',
    no_routes_by_turnover_limits: '付款遭拒絕（超過限額）',
    no_routes_by_merchant_account_limits: '付款遭拒絕（超過限額）',
    unable_to_cascade: '無法處理付款',
    no_routes_by_payment_request_options: '無法處理付款',
    no_routes_by_merchant_account_status: '無法處理付款',
    no_routes_by_payment_request_flow: '無法處理付款',
    no_routes_by_conditions: '無法處理付款',
    no_routes_by_balance: '無法處理付款',
    no_routes_by_history: '無法處理付款',
    no_available_routes: '無法處理付款',
    unable_to_cascade_due_to_payment_resolution: '無法處理付款',
    no_routes_by_status: '無法處理付款',
    unknown: '無法處理付款',
  },
};
